/* eslint-disable no-useless-concat */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import {
  DDMMYYYY_formate,
  DMMMYYYY_formate,
  Ddmmmyyyy_date,
  Detailsshow,
  MyModal,
  calculateAge,
  capitalizeWords,
  dateFormateDD,
  decryptedAdminID,
  sources,
  textTruncate,
} from "../../../utility";
import ModalContainer from "../../modal_popup";
import DetailsContainer from "../../DetailsContainer";
import Candidatedetailstyle from "./CandidateDetails.module.scss";
import { useEffect } from "react";
import {
  GetAllAdminDetails,
  getJobRole,
  GetCandidateQualifyForm,
  GetQualifiedForm,
  PutCandidateInterviewFollowup,
  PutCandidateAssignto,
  PutCandidateIsQualified,
  getCandidateDocument,
  getDocumentCandidate,
  getcandidateDetails,
  GetCompanyName,
  PutCandidateType,
  PutCandidateJoinedFollowUp,
  GetcanInterviews,
  getCandidateLead,
  PostCandidateDocument,
  GetPipelineStages,
  PutResetCandidate,
  PostCallReaminder,
  adminNameOnlyGet,
  putCanLeadData,
  putCandidateData,
  updateInterviewActiveStatus,
  GetAiCallData,
  getCandidateIdByleadId,
  PutFromSource,
} from "../../../apiServices";
import companylogo from "../../../assets/images/user.png";
import { GrDocumentUpdate } from "react-icons/gr";
import accordionstyle from "../../../pages/Candidate/CandidateQualifyForm/QualifyForm.module.scss";
import { AiOutlineClose } from "react-icons/ai";
import { useRef } from "react";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { LiaUserEditSolid } from "react-icons/lia";
import { FaWhatsapp } from "react-icons/fa";
import { CgPlayListCheck } from "react-icons/cg";
import flag from "../../../assets/images/flag.png";
import Documents from "../../../assets/images/Documents.png";
import DocumentsEd from "../../../assets/images/pdf_img.png";
import DocumentsD from "../../../assets/images/word_img.png";
import DocumentsA from "../../../assets/images/img_img.png";
import WhatsappImage from "../../../assets/images/whatsapp-logo-removebg-preview.png";
import {
  LuCalendarCheck2,
  LuCalendarClock,
  LuCalendarSync,
} from "react-icons/lu";
import {
  MdCall,
  MdNotificationAdd,
  MdOutlineContentCopy,
  MdOutlineUploadFile,
} from "react-icons/md";
import candidateTabsviewStyle from "../../../pages/Tabsview/Candidate/CandidateTabsview.module.scss";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CandidateTimeline from "../../../pages/Candidate/CandidateTimeLine/CandidateTimeline";
import TimeLineForm from "../../../pages/Candidate/CandidateTimeLine/components/timeLinePost";
import { styled as muiStyled } from "@mui/material/styles";
import {
  TextField,
  Backdrop,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Autocomplete,
} from "@mui/material";
import ScheduleInterview from "../../../pages/Candidate/CandidateInterview/scheduleInterview";
import { webConsoleBaseUrl } from "../../../App";
import {
  CandidatePipelineActions,
  commonPopupActions,
  interviewListActions,
} from "../../../redux-store/store";
import { useDispatch, useSelector } from "react-redux";
import SuccessTick from "../../success_tick";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  TbCalendarRepeat,
  TbCalendarStats,
  TbCalendarUser,
} from "react-icons/tb";
import UpdateFresherForm from "../../../pages/Candidate/CandidateUpdateQualifyForm/UpdateFresherForm";
import UpdateExperienceForm from "../../../pages/Candidate/CandidateUpdateQualifyForm/UpdateExperienceForm";
import { SlCalender } from "react-icons/sl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InterviewReschedule from "../../../pages/Candidate/CandidateInterview/interviewReschedule.";
import { FormGroup, FormLabel } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { GoDotFill } from "react-icons/go";
import { BiUserCircle } from "react-icons/bi";
import { LoadingButton } from "@mui/lab";
import { IoMdCheckmarkCircle, IoMdClose } from "react-icons/io";
import { DeleteOutline } from "@mui/icons-material";
import { HiPencilAlt } from "react-icons/hi";
const VisuallyHiddenInput = muiStyled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: "50px",
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const buttonStyle = {
  margin: "0 auto",
  marginTop: "5vh",
};
const CandidateDetailsview = ({ Id, textHeading }) => {
  const candidateId = Id;
  const currentDate = new Date().toISOString().split("T")[0];
  const [shouldReload, setShouldReload] = useState(false);
  const [adminName, setAdminName] = useState([]);
  const [options, setOptions] = useState({ jobRoles: [] });
  const [adminid, setAdminId] = useState([]);
  const [assignToName, setAssignToName] = useState("");
  const [CandidateInterviewList, setCandidateInterviewList] = React.useState(
    []
  );
  const [callDetails, setCallDetails] = useState(null);
  const [canReferenceID, setcanReferenceID] = useState();
  const [showModal, setShowModal] = useState(false);
  const [openCallRemainder, setopenCallReaminder] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [enableSubmit, setenableSubmit] = useState(false);
  const [interviewActive, setInterviewActive] = useState(false);
  const [activeCompanyName, setActiveCompanyName] = useState({});
  const [candiateDetails, setCandidateDetails] = useState({});
  const [stage, setStage] = useState(null);
  const [pipeline, setPipeLine] = useState(null);
  const [noDataMessage, setNoDataMessage] = useState("");
  const [notes, setNotes] = useState("");

  const [isQualifiedDetails, setIsQualifiedDetails] = useState({
    confirmtext: "",
    notes: "",
    isQualified: "",
    openPopup: false,
    candidateId: "",
  });
  const [callRemainder, setCallRemainder] = useState({
    notes: "",
    date: null,
    ctc: "",
  });
  const [activeTab, setActiveTab] = useState(1);
  const [detailsactiveTab, setDetailsActiveTab] = useState(1);
  const [fileName, setFileName] = useState("");
  const [showConfirmationPopup, setShowConfirmPopup] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [showConfirmationqualifiedPopup, setShowConfirmQualifiedPopup] =
    useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [oponUpdateForm, setoponUpdateForm] = useState(false);
  const [deleteCandidate, setdeleteCandidate] = useState(false);
  const [oponResetCandidate, setoponResetCandidate] = useState(false);
  const [followUpDateopen, setfollowUpDateopen] = useState(false);
  const [followUpDateopenupdate, setfollowUpDateopenupdate] = useState(false);
  const [joiningFollowupdateupdate, setJoiningFollowupdateupdate] =
    useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [fileError, setFileError] = useState("");
  const [documentTypeError, setDocumentTypeError] = useState("");
  const [documents, setDocuments] = useState([]);
  const [candiateQualifyDetails, setcandiateQualifyDetails] = useState([]);
  const [ShowModal, SetShowModal] = useState(false);
  const [open, setOpen] = React.useState(false);
  const adminId = decryptedAdminID();
  const [selectedDate, setSelectedDate] = useState({
    tentativeInterviewDate: null,
    followUpDate1: null,
  });
  const [joiningselectedDate, setjoiningSelectedDate] = useState({
    tentativeJoinedDate: null,
    followUpDate1: null,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [updateName, setupdateName] = useState({
    candidateId: "",
    fromSource: "",
  });
  const [validity, setValidity] = useState({
    isFollowDate1: true,
    isFollowDate2: true,
  });
  const [joiningvalidity, setjoiningValidity] = useState({
    isFollowDate1: true,
    isFollowDate2: true,
  });
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID === 1;
  let isAdmin = localStorage.getItem("adminID");
  let adminuserName = localStorage.getItem("adminuserName");
  let teamLeader = localStorage.getItem("teamLeader");
  const [assignAdminto, setAssignAdminto] = useState({
    candidateId: "",
    adminId: "",
  });
  const [adminDetails, setAdminDetails] = useState({
    id: null,
    adminName: [],
  });
  const interviewFilter = useSelector(
    (state) => state.interviewListDetails.interviewActive
  );
  let candidateAdmin = parseInt(decryptedAdminID());
  // console.log(candidateAdmin);

  const TodayDateCal = new Date();
  const tomorrowDateCal = new Date();
  tomorrowDateCal.setDate(tomorrowDateCal.getDate() + 1);
  const [companyNames, setCompanyNames] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyNameError, setCompanyNameError] = useState(false);
  const [jobCategoryError, setJobCategoryError] = useState(false);
  const [canInterviewDetails, setcanInterviewDetails] = useState();
  const [openReschedule, setopenReschedule] = useState(false);
  const [selectedJobCategory, setSelectedJobCategory] = useState(null);

  const localTime = new Date();
  localTime.setSeconds(0);
  localTime.setMilliseconds(0);
  const maxDate = new Date(localTime.getTime() + 15 * 24 * 60 * 60 * 1000);
  const Dispatch = useDispatch();
  function handleClose() {
    Dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetailsclose",
      })
    );
    Dispatch(CandidatePipelineActions.setRefreshCount());
  }
  const handlePopupDetails = (id, type) => {
    Dispatch(
      commonPopupActions.setShowPopup({
        name: type,
        id: id,
      })
    );
  };
  const handleCandidateDetails = async (candidateId, type) => {
    let data;
    if (type === "RegisterCandidate") {
      data = await getcandidateDetails(candidateId);
    } else if (type === "CandidateLead") {
      data = await getCandidateLead(candidateId);
    }

    // Dispatch action to show the popup and pass the fetched data
    Dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetails",
        id: candidateId,
        type: type,
        data: data,
      })
    );
  };
  const handleCancelClick = () => {
    setShowConfirmQualifiedPopup(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!candidateId) return;

        const data = await getCandidateIdByleadId(candidateId);
        const canId = data.can_lead_id;

        // console.log("canId:", canId);

        if (canId) {
          const callData = await GetAiCallData({ id: canId });
          setCallDetails(callData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [candidateId]);

  const handleConfirmReset = async () => {
    setenableSubmit(true);
    try {
      const response = await PutResetCandidate(candiateDetails.id);
      console.log("API Response:", response);

      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        setoponResetCandidate(false);
        setenableSubmit(false);
        getcandidateDetails(candidateId).then((data) => {
          setCandidateDetails(data);
        });
        reloadCanTimeline();
      }, 2000);
    } catch (error) {
      console.error("Error resetting candidate:", error);
    }
  };

  function copyToClipboard(text) {
    const textField = document.createElement("textarea");
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    document.body.removeChild(textField);
  }
  function handleConfirmationOpenQualify() {
    setShowConfirmQualifiedPopup(true);
  }

  const handleClos = () => {
    setOpen(false);
  };

  function handleConfirmationOpen() {
    setShowConfirmPopup(true);
  }

  const handleCancelClicknotqualify = () => {
    setShowConfirmPopup(false);
  };
  const uploadButtonClick = () => {
    SetShowModal(true);
  };

  useEffect(() => {
    getJobRole(1).then((data) => {
      let jobRoles = data.results.map((el) => el.jobRoles);
      setOptions((prev) => ({ ...prev, jobRoles: [...jobRoles] }));
    });
  }, []);

  const validateForm = () => {
    let errors = {};

    // Validate Select Document
    if (!selectedDocumentType) {
      errors.selectedDocumentType = "Please select a document type.";
    }

    // Validate Upload File
    if (!selectedFile) {
      errors.selectedFile = "Please upload a file.";
    }

    return errors;
  };
  // useEffect(() => {}, [CanList]);
  const submitForm = async () => {
    try {
      // Open the backdrop
      const errors = validateForm();

      if (Object.keys(errors).length > 0) {
        // Display error messages and do not proceed with form submission
        setDocumentTypeError(errors.selectedDocumentType || "");
        setFileError(errors.selectedFile || "");

        return;
      }
      setOpen(true);

      // Call the API function with the required parameters
      // PutCandidateDocument(
      //   candiateDetails.mobileNumber, // Replace with the actual mobile number
      //   selectedDocumentType,
      //   adminId, // Replace with the actual admin ID
      //   selectedFile // Pass the selected file to the function
      // )
      PostCandidateDocument(
        candiateDetails.id,
        selectedDocumentType,
        selectedFile
      )
        .then((result) => {
          // Close the backdrop
          setOpen(false);
          fetchDocuments();
          setFileName("");
          setSelectedFile(null);

          // Close the modal
          SetShowModal(false);
        })
        .catch(() => {});
    } catch (error) {
      console.error("Error submitting form:", error);

      // Close the backdrop in case of an error
      setOpen(false);
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileError("");
    if (file) {
      setSelectedFile(file);
      setFileName(file.name);
      // You can also perform additional actions with the selectedFile if needed
    } else {
      // User canceled file selection
      setSelectedFile(null);
      setFileName(""); // Clear the file name
    }
  };
  const fetchDocuments = async () => {
    try {
      const data = await getDocumentCandidate(candiateDetails.id);
      setDocuments(data);
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };
  useEffect(() => {
    fetchDocuments();
  }, [candiateDetails]);

  useEffect(() => {
    GetQualifiedForm(" ", candidateId).then((data) => {
      setcandiateQualifyDetails(data);
    });
  }, []);

  useEffect(() => {
    async function fetchData() {
      const data = await GetCompanyName();
      setCompanyNames(data.companyDetails);
      // console.log(data.companyDetails, "datta");
    }
    fetchData();
  }, []);
  const handleMobileNumberChange = (value) => {
    Dispatch(
      interviewListActions.setInterviewFilterCandidateMobileNumber(value)
    );
  };
  useEffect(() => {
    if (interviewFilter.candidateMobileNumber != null) {
      GetcanInterviews(interviewFilter).then((data) => {
        const InterviewList = data.canInterviewList.map((item) => item);
        setCandidateInterviewList(InterviewList);
      });
    }
  }, [interviewFilter]);

  const importantKeys = [
    { label: "Name", key: "candidateName" },
    { label: "Role", key: "jobRole" },
    { label: "Exp.", key: "yearsofExperience" },
    // { label: "Current Salary", key: "currentSalary" },
    { label: "Expected Salary", key: "expectedSalary" },
    { label: "Preferred City", key: "preferredCity" },
    // { label: "Job Status", key: "jobStatus" },
    { label: "Immediate Joiner", key: "immediateJoinerBoolean" },
    { label: "Created Time", key: "created_at" },
  ];

  const handleopenCandidateUpdate = () => {
    handleupdateConfirmationOpen();
  };
  function handleupdateConfirmationOpen() {
    setoponUpdateForm(true);
    GetCandidateQualifyForm(candiateDetails.mobileNumber)
      .then((data) => {
        if (data) {
          setSelectedOption(
            data?.candidateType === "Experienced" ? "experience" : "fresher"
          );
        } else {
          console.error("CanLeadDetails not available in data:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching candidate details:", error);
      });
  }
  function handleCloseupdateForm() {
    setSelectedOption("");
    setoponUpdateForm(false);
    getcandidateDetails(candidateId).then((data) => {
      setCandidateDetails(data);
    });
  }
  function handleQualifyFormSubmit() {
    setShowSuccess(true);

    setTimeout(() => {
      setShowSuccess(false);
      setSelectedOption("");
      setoponUpdateForm(false);
    }, 1000);
    getcandidateDetails(candidateId).then((data) => {
      setCandidateDetails(data);
    });
  }
  useEffect(() => {
    getcandidateDetails(candidateId).then((data) => {
      setCandidateDetails(data);
    });
    <CandidateTimeline />;
  }, []);
  const handleOptionChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);

    let experiencedValue = false;
    if (selectedValue === "experience") {
      experiencedValue = true;
    }

    PutCandidateType(experiencedValue, candiateDetails.mobileNumber, "").then(
      (data) => {}
    );
  };
  const handleDocumentTypeChange = (event) => {
    setSelectedDocumentType(event.target.value);
    setDocumentTypeError("");
  };

  // const navigate = useNavigate();

  const [showScheduleInterview, setShowScheduleInterview] = useState(true);
  const [showInterviewdateupdate, setShowInterviewdateupdate] = useState(true);

  useEffect(() => {
    const params = window.location.href;

    let isShowScheduleInterview =
      params.includes("CandidateTabsview#Joined") ||
      params.includes("CandidateTabsview#interviews");
    // console.log(params, "parameterrrs");
    setShowScheduleInterview(!isShowScheduleInterview);
  }, []);

  const [documentTitles, setDocumentTitles] = useState([]);

  useEffect(() => {
    async function fetchDocumentTitles() {
      try {
        const response = await getCandidateDocument();
        setDocumentTitles(response.map((doc) => doc.docTitle));
      } catch (error) {
        console.error("Error fetching document titles:", error);
      }
    }

    fetchDocumentTitles();
  }, []);
  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };
  const handlepersonalTabClick = (tabNumber) => {
    setDetailsActiveTab(tabNumber);
  };

  // function reloadCanTimeline() {
  //   <CandidateTimeline canId={candidateId} />;
  // }
  function reloadCanTimeline() {
    setShouldReload((prev) => !prev); // Toggle reload state
  }
  useEffect(() => {
    getcandidateDetails(candidateId).then((data) => {
      setCandidateDetails(data);
    });
    reloadCanTimeline();
  }, [candidateId]);
  function handleReset() {
    setShowSuccess(true);
    setTimeout(() => {
      getcandidateDetails(candidateId).then((data) => {
        setCandidateDetails(data);
      });
      GetcanInterviews(interviewFilter).then((data) => {
        const InterviewList = data.canInterviewList.map((item) => item);
        setCandidateInterviewList(InterviewList);
      });
      Dispatch(CandidatePipelineActions.setRefreshCount());
      setShowSuccess(false);
    }, 2000);
  }

  const handleInterviewActive = async (e) => {
    setenableSubmit(true);
    // console.log(e,"company");
    const obj = {
      can_id: e.canId,
      id: e.id,
    };

    try {
      const response = await updateInterviewActiveStatus(obj);
      // console.log("API Response:", response);
      if (!response.success) {
        alert("ID Not Found");
        setenableSubmit(false);
        return;
      }
      // setShowSuccess(true);
      handleReset();
      setTimeout(() => {
        // setShowSuccess(false);
        setInterviewActive(false);
        setenableSubmit(false);
      }, 2000);
    } catch (error) {
      console.error("Error resetting candidate:", error);
    }
  };
  const inputRef = {
    qualified: useRef(),
    notQualified: useRef(),
    // rescheduled: useRef(),
  };
  const handleButtonClick = (refName) => {
    const ref = inputRef[refName];
    if (ref.current) {
      ref.current.click();
    }
  };
  function openIsQualifyPopup(status) {
    let confirmText = "";
    let isQualified;
    if (status === "qualify") {
      confirmText = `Are you sure you want to qualify ${candiateDetails.firstName} `;
      isQualified = true;
    } else {
      confirmText = `Are you sure you want to not qualify ${candiateDetails.firstName} `;
      isQualified = false;
    }
    setIsQualifiedDetails((prev) => ({
      ...prev,
      openPopup: true,
      isQualified: isQualified,
      confirmtext: confirmText,
      candidateId: candiateDetails.id,
    }));
  }

  useEffect(() => {
    if (assignAdminto.adminId && assignAdminto.candidateId) {
      PutCandidateAssignto(assignAdminto).then((data) => {
        if (data.code !== 200) {
          alert("something went wrong");
          return false;
        }
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
        }, 3000);
        // onAssignChange();
        getcandidateDetails(candidateId).then((data) => {
          setCandidateDetails(data);
        });
      });
    }
  }, [assignAdminto]);

  const handleLeadAssignfromAdmin = (candidateId, adminId) => {
    // let selectedAdminName = event.target.value;
    setAssignAdminto((prev) => ({
      ...prev,
      candidateId: candidateId,
      adminId: adminId,
    }));
  };
  useEffect(() => {
    adminNameOnlyGet().then((data) => {
      console.log(data, "All admin details");
      const adminNames = data.map((item) => item.userName);
      const adminIds = data.map((item) => item.id);
      setAdminName(adminNames);
      console.log(adminNames);
      setAdminId(adminIds);
      setAdminDetails((prev) => ({
        ...prev,
        adminName: adminNames,
        id: adminIds,
      }));
    });
  }, []);

  useEffect(() => {
    const assignToIndex = adminid.indexOf(candiateDetails.assignTo);
    if (assignToIndex !== -1) {
      setAssignToName(adminName[assignToIndex]);
    }
  }, [candiateDetails.assignTo, adminid, adminName]);
  function ConfirmFormSubmit() {
    PutCandidateIsQualified(isQualifiedDetails)
      .then((data) => {
        setIsQualifiedDetails((prev) => ({
          confirmtext: "",
          notes: "",
          isQualified: "",
          openPopup: false,
          candidateId: "",
        }));
        getcandidateDetails(candidateId).then((data) => {
          console.log(data);
          setCandidateDetails(data);
        });
        setShowConfirmPopup(false);
        setShowConfirmQualifiedPopup(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function renderDocumentImage(docKey) {
    if (docKey == null) {
      return (
        <img
          src={Documents} // Add a default or placeholder image
          alt="Default Image"
          style={{ width: "50px", height: "50px" }}
        />
      );
    }

    switch (docKey.toUpperCase()) {
      case "A":
        return (
          <img
            src={DocumentsA}
            alt="Aadhaar Card"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "D":
        return (
          <img
            src={DocumentsD}
            alt="Driving License"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "ED":
        return (
          <img
            src={DocumentsEd}
            alt="Education Certificate"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "V":
        return (
          <img
            src={DocumentsD}
            alt="Voter ID"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "Re":
        return (
          <img
            src={DocumentsEd}
            alt="Resume"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "Ex":
        return (
          <img
            src={DocumentsEd}
            alt="Experience Certificate"
            style={{ width: "50px", height: "50px" }}
          />
        );
      case "Sl":
        return (
          <img
            src={DocumentsEd}
            alt="salary slip"
            style={{ width: "50px", height: "50px" }}
          />
        );
      // Add cases for other docKey values and their respective images
      default:
        return (
          <img
            src={Documents}
            alt="Default Image"
            style={{ width: "50px", height: "50px" }}
          />
        );
    }
  }

  const handleWhatsAppIconClick = (phoneNumber) => {
    // console.log(event)
    const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}`;
    window.open(whatsappURL, "_blank");
  };
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyNumber = (phoneNumber, whatsappNumber) => {
    navigator.clipboard.writeText(phoneNumber, whatsappNumber).then(() => {
      setIsCopied(true);
    });
  };
  // if (!candiateDetails || !candiateDetails.keySkill) {
  //   return <div></div>;
  // }

  // // Check if keySkill is a string
  // if (typeof candiateDetails.keySkill !== "string") {
  //   return <div>Invalid key skills format</div>;
  // }
  const keySkillsArray =
    candiateDetails.keySkill && typeof candiateDetails.keySkill === "string"
      ? candiateDetails.keySkill.split(",")
      : [];
  const certificationArray =
    candiateDetails.certificationCourses &&
    typeof candiateDetails.certificationCourses === "string"
      ? candiateDetails.certificationCourses.split(",")
      : [];
  const AgeCalculate = calculateAge(candiateDetails.dateOfBirth);
  const isSunday = (date) => {
    const day = date.getDay();
    return day !== 0; // 0 is Sunday
  };

  const filterFollowUpDate = (date) => {
  if (!selectedDate.tentativeInterviewDate) return true;

  const tentativeDay = selectedDate.tentativeInterviewDate.getDay(); // 1 = Monday
  const day = date.getDay(); // 0 = Sunday, 6 = Saturday

  // If tentative date is Monday → disable Saturday & Sunday
  if (tentativeDay === 1) {
    return day !== 0 && day !== 6;
  }

  // Otherwise → disable only Sunday
  return day !== 0;
};
  const handleDateChange = (date, type) => {
  setSelectedDate((prevState) => ({
    ...prevState,
    [type]: date,
  }));

  // Tentative Date logic
  if (type === "tentativeInterviewDate") {
    // If tentative is Monday & follow-up is Sat/Sun → clear follow-up
    if (date?.getDay() === 1 && selectedDate.followUpDate1) {
      const followUpDay = selectedDate.followUpDate1.getDay();
      if (followUpDay === 0 || followUpDay === 6) {
        setSelectedDate((prev) => ({
          ...prev,
          followUpDate1: null,
        }));
        setValidity((prev) => ({
          ...prev,
          isFollowDate2: false,
        }));
      }
    }

    setValidity((prev) => ({
      ...prev,
      isFollowDate1: !!date,
    }));
  }

  // Follow-up Date logic
  if (type === "followUpDate1") {
    setValidity((prev) => ({
      ...prev,
      isFollowDate2: !!date,
    }));
  }
};


  // const handleDateChange = (date, type) => {
  //   setSelectedDate((prevState) => ({
  //     ...prevState,
  //     [type]: date,
  //   }));

  //   if (type === "tentativeInterviewDate") {
  //     if (
  //       selectedDate.followUpDate1 &&
  //       date &&
  //       selectedDate.followUpDate1 < date
  //     ) {
  //       setSelectedDate((prevState) => ({
  //         ...prevState,
  //         followUpDate1: null,
  //       }));
  //       setValidity((prevState) => ({
  //         ...prevState,
  //         isFollowDate2: false,
  //       }));
  //     }
  //     setValidity((prevState) => ({
  //       ...prevState,
  //       isFollowDate1: !!date,
  //     }));
  //   } else if (type === "followUpDate1") {
  //     setValidity((prevState) => ({
  //       ...prevState,
  //       isFollowDate2: !!date,
  //     }));
  //   }
  // };
  const handlejoiningDateChange = (date, type) => {
    setjoiningSelectedDate((prevState) => ({
      ...prevState,
      [type]: date,
    }));

    if (type === "tentativeJoinedDate") {
      if (
        joiningselectedDate.followUpDate1 &&
        date &&
        joiningselectedDate.followUpDate1 < date
      ) {
        setjoiningSelectedDate((prevState) => ({
          ...prevState,
          followUpDate1: null,
        }));
        setjoiningValidity((prevState) => ({
          ...prevState,
          isFollowDate2: false,
        }));
      }
      setjoiningValidity((prevState) => ({
        ...prevState,
        isFollowDate1: !!date,
      }));
    } else if (type === "followUpDate1") {
      setjoiningValidity((prevState) => ({
        ...prevState,
        isFollowDate2: !!date,
      }));
    }
  };

  const dateDiff = Math.ceil(
    (selectedDate.tentativeInterviewDate - new Date()) / (1000 * 60 * 60 * 24)
  );
  const dateDiff1 = Math.ceil(
    (joiningselectedDate.tentativeJoinedDate - new Date()) /
      (1000 * 60 * 60 * 24)
  );
  const handleSubmitUpdate = (e) => {
    e.preventDefault();

    if (!selectedDate.tentativeInterviewDate) {
      setValidity((prevState) => ({
        ...prevState,
        isFollowDate1: false,
      }));
      return;
    }

    if (dateDiff >= 4 && !selectedDate.followUpDate1) {
      setValidity((prevState) => ({
        ...prevState,
        isFollowDate2: false,
      }));
      return;
    }

    if (!selectedCompany) {
      setCompanyNameError(true);
      return;
    }

    if (!selectedJobCategory) {
      setJobCategoryError(true);
      return;
    }

    setenableSubmit(true);

    PutCandidateInterviewFollowup(
      candidateId,
      selectedDate,
      selectedCompany,
      selectedJobCategory,
      false
    )
      .then((data) => {
        setShowSuccess(true);
        console.log(data, "interviewFollowDate");

        setTimeout(() => {
          setShowSuccess(false);
          setfollowUpDateopenupdate(false);
          setenableSubmit(false);

          setSelectedDate((prev) => ({
            ...prev,
            tentativeInterviewDate: "",
            followUpDate1: "",
          }));
          getcandidateDetails(candidateId).then((data) => {
            setCandidateDetails(data);
          });

          setSelectedCompany(null); // Directly set the company to null
          setCompanyNameError(false); // Reset error state

          setSelectedJobCategory(null); // Directly set the job category to null
          setJobCategoryError(false); // Reset error state
        }, 1000);

        Dispatch(CandidatePipelineActions.setRefreshCount());
      })
      .catch((error) => {
        console.error("Error submitting interview follow-up:", error);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedDate.tentativeInterviewDate) {
      setValidity((prevState) => ({
        ...prevState,
        isFollowDate1: false,
      }));
      return;
    }

    if (dateDiff >= 4 && !selectedDate.followUpDate1) {
      setValidity((prevState) => ({
        ...prevState,
        isFollowDate2: false,
      }));
      return;
    }

    if (!selectedCompany) {
      setCompanyNameError(true);
      return;
    }

    if (!selectedJobCategory) {
      setJobCategoryError(true);
      return;
    }

    setenableSubmit(true);

    PutCandidateInterviewFollowup(
      candidateId,
      selectedDate,
      selectedCompany,
      selectedJobCategory,
      false
    )
      .then((data) => {
        setShowSuccess(true);
        console.log(data, "interviewFollowDate");

        setTimeout(() => {
          setShowSuccess(false);
          setfollowUpDateopen(false);
          setenableSubmit(false);

          setSelectedDate((prev) => ({
            ...prev,
            tentativeInterviewDate: "",
            followUpDate1: "",
          }));

          setSelectedCompany(null); // Directly set the company to null
          setCompanyNameError(false); // Reset error state

          setSelectedJobCategory(null); // Directly set the job category to null
          setJobCategoryError(false); // Reset error state
        }, 1000);

        getcandidateDetails(candidateId).then((data) => {
          setCandidateDetails(data);
        });
        reloadCanTimeline();
        Dispatch(CandidatePipelineActions.setRefreshCount());
      })
      .catch((error) => {
        console.error("Error submitting interview follow-up:", error);
      });
  };

  const handlejoiningSubmitUpdate = (e) => {
    e.preventDefault();

    if (!joiningselectedDate.tentativeJoinedDate) {
      setjoiningValidity((prevState) => ({
        ...prevState,
        isFollowDate1: false,
      }));
      return;
    } else if (dateDiff1 >= 4 && !joiningselectedDate.followUpDate1) {
      setjoiningValidity((prevState) => ({
        ...prevState,
        isFollowDate2: false,
      }));
      return;
    }
    setenableSubmit(true);
    PutCandidateJoinedFollowUp(candidateId, joiningselectedDate)
      .then((data) => {
        setShowSuccess(true);
        console.log(data, "interviewFollowDate");
        setTimeout(() => {
          setShowSuccess(false);
          setenableSubmit(false);
          setJoiningFollowupdateupdate(false);
          setjoiningSelectedDate((prev) => ({
            ...prev,
            tentativeJoinedDate: "",
            followUpDate1: "",
          }));
        }, 1000);
        getcandidateDetails(candidateId).then((data) => {
          setCandidateDetails(data);
        });
        reloadCanTimeline();
        Dispatch(CandidatePipelineActions.setRefreshCount());
      })
      .catch((error) => {
        console.error("Error submitting interview follow-up:", error);
      });
  };

  const handleCompanyNameChange = (selected) => {
    if (selected.length > 0) {
      setSelectedCompany(JSON.stringify(selected[0]));
      setCompanyNameError(false);
    } else {
      setSelectedCompany(null);
      setCompanyNameError(true);
    }
  };

  function handleInterviewDateClose() {
    setfollowUpDateopen(false);
    setSelectedDate((prev) => ({
      ...prev,
      tentativeInterviewDate: "",
      followUpDate1: "",
    }));
    setSelectedCompany((prev) => ({
      ...prev,
      selectedCompany: "",
    }));
    setSelectedCompany("");
    setSelectedJobCategory((prev) => ({
      ...prev,
      selectedJobCategory: "",
    }));
    setSelectedJobCategory("");
    setCompanyNameError("");
    setJobCategoryError("");
    getcandidateDetails(candidateId).then((data) => {
      setCandidateDetails(data);
    });
    <CandidateTimeline canId={candidateId} />;
  }
  function handleInterviewDateCloseupdate() {
    setfollowUpDateopenupdate(false);
    setSelectedDate((prev) => ({
      ...prev,
      tentativeInterviewDate: "",
      followUpDate1: "",
    }));
    setSelectedCompany((prev) => ({
      ...prev,
      selectedCompany: "",
    }));
    setSelectedCompany("");
    setSelectedJobCategory((prev) => ({
      ...prev,
      selectedJobCategory: "",
    }));
    setSelectedJobCategory("");
    setCompanyNameError("");
    setJobCategoryError("");
  }
  function handleJoiningDateCloseupdate() {
    setJoiningFollowupdateupdate(false);
    setSelectedDate((prev) => ({
      ...prev,
      tentativeJoinedDate: "",
      followUpDate1: "",
    }));
  }

  useEffect(() => {
    const fetchPipelineStages = async () => {
      try {
        const response = await GetPipelineStages(candiateDetails.mobileNumber);
        if (response && response.statusCode === 200) {
          if (response.Stage && response.PipeLine) {
            setStage(response.Stage);
            setPipeLine(response.PipeLine);
          } else {
            setNoDataMessage("Number Not Exists.");
          }
        } else {
          setNoDataMessage("Failed to retrieve data.");
        }
      } catch (error) {
        console.error("Error fetching pipeline stages:", error);
        setNoDataMessage("An error occurred while fetching data.");
      }
    };

    if (candiateDetails.mobileNumber) {
      fetchPipelineStages();
    }
  }, [candiateDetails.mobileNumber]);
  // function handleScheduleSubmit(){
  //   setfollowUpDateopen(false);
  // }

  const getAdminName = (assignToId) => {
    const index = adminDetails.id.indexOf(assignToId);
    return index >= 0 ? adminDetails.adminName[index] : "Unknown Admin";
  };

  function handleEmptyDate() {
    setSelectedDate((pre) => ({ ...pre, tentativeInterviewDate: "" }));
    setfollowUpDateopen(false);
    setfollowUpDateopenupdate(false);

    Dispatch(CandidatePipelineActions.setRefreshCount());
  }
  function handleOpenReschedule() {
    setopenReschedule(true);
  }
  function closeRescheduleModal() {
    setopenReschedule(false);
  }

  function handleOpenSetCallRemainder() {
    setopenCallReaminder(true);
  }
  function handleCloseCallRemainder() {
    setopenCallReaminder(false);
  }
  const handleOnsubmitCallRemainder = async (e) => {
    e.preventDefault();
    const [callRemainderDate, callRemainderTime] =
      callRemainder.date.split("T");

    const payload = {
      // adminId: decryptedAdminID(),
      callRemainderDate: callRemainderDate,
      callRemainderTime: callRemainderTime,
      notes: callRemainder.notes,
      remainderSubject: "Custom Call Remainder",
      canId: { id: candidateId },
    };
    setenableSubmit(true);
    try {
      const response = await PostCallReaminder(payload, "canId");
      setShowSuccess(true);

      setTimeout(() => {
        setenableSubmit(false);
        setShowSuccess(false);
        setopenCallReaminder(false);
        setCallRemainder((prev) => ({
          ...prev,
          notes: "",
        }));
      }, 2000);
      // console.log("Response:", response);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  function deleteLead() {
    setenableSubmit(true);
    let obj = {
      id: candidateId,
      notes: notes, // pass the notes here
    };

    setShowSuccess(true);
    putCandidateData(obj).then(() => {
      setdeleteCandidate(false);
      setenableSubmit(false);
      Dispatch(CandidatePipelineActions.setRefreshCount());
    });

    setTimeout(() => {
      setShowSuccess(false);
      setenableSubmit(false);
      setNotes(""); // clear notes after submission
      handleClose();
      Dispatch(
        interviewListActions.setInterviewFilterCandidateMobileNumber(null)
      );
    }, 1000);
  }

  function handleCallRemainderChange(name, value) {
    //console.log(value, "date formate");
    if (name === "date") {
      // setDateTimeError(false);
      setCallRemainder((prev) => ({ ...prev, [name]: value }));
    } else {
      setCallRemainder((prev) => ({ ...prev, [name]: value }));
    }
  }
  const startEditing = (candidate) => {
    setupdateName({
      candidateId: candidate.id,
      fromSource: candidate.fromSource || "",
    });
    setIsEditing(true); // Show the editing interface
  };
  function handleFieldChange(field, value) {
    setupdateName((prev) => ({ ...prev, [field]: value }));
  }

  const submitNameChange = (id) => {
    const payload = {
      id: id,
      fromSource: capitalizeWords(updateName.fromSource),
      assignTo: parseInt(adminId),
    };

    PutFromSource(payload)
      .then(() => {
        setShowSuccess(true);
        //console.log(payload, "updatename");
        // return GetInterviewListByJobId(formData);
        setTimeout(() => {
          setShowSuccess(false);
          setIsEditing(false);
        }, 1000);
        getcandidateDetails(candidateId).then((data) => {
          setCandidateDetails(data);
        });
        reloadCanTimeline();
      })
      .catch((error) => {
        console.error(
          "There was an error updating the candidate name or fetching the updated list:",
          error
        );
      });
  };
  return (
    <div>
      <Detailsshow>
        <DetailsContainer
          topComponent={
            <>
              <div className={`${Candidatedetailstyle.boxcross}`}>
                <div className="d-flex justify-content-between">
                  <div>
                    <h4 className="text-light ms-3">{textHeading}</h4>
                  </div>
                  <div
                    className={` ${Candidatedetailstyle.CrossStyle} pe-5 pe-lg-4`}
                  >
                    <b>
                      <RxCross2
                        onClick={() => {
                          handleClose();
                          Dispatch(
                            interviewListActions.setInterviewFilterCandidateMobileNumber(
                              null
                            )
                          );
                        }}
                      />
                    </b>
                  </div>
                </div>
              </div>
            </>
          }
          childComponent={
            <>
              <div className={`${Candidatedetailstyle.boxwidth}`}>
                <div className="container-fluid">
                  <div className={`row ${Candidatedetailstyle.topcontainer}`}>
                    <div className="col-sm-4">
                      <div className="row">
                        <div className="col-sm-4">
                          {" "}
                          {candiateDetails.profilePic ? (
                            <img
                              src={candiateDetails.profilePic}
                              alt="Candidate Profile"
                              width={70}
                            />
                          ) : (
                            <img src={companylogo} alt="Profile" width={100} />
                          )}
                        </div>
                        <div className="col-sm-6">
                          <div>
                            <b>
                              {capitalizeWords(candiateDetails.firstName) +
                                " " +
                                (candiateDetails.lastName != null
                                  ? capitalizeWords(candiateDetails.lastName) +
                                    ""
                                  : "")}
                            </b>
                          </div>

                          <div>
                            {candiateDetails.jobCategory ? (
                              <>
                                {capitalizeWords(candiateDetails.jobCategory)}
                              </>
                            ) : (
                              <> {"Fresher"}</>
                            )}{" "}
                          </div>
                          <div>
                            {" "}
                            <strong>Age : </strong>
                            {AgeCalculate}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              whiteSpace: "nowrap",
                              flexWrap: "nowrap",
                            }}
                          >
                            <strong>From Source :</strong>

                            <span>
                              {candiateDetails.fromSource != null
                                ? candiateDetails.fromSource
                                : "-"}
                            </span>

                            {isSuperAdmin && (
                              <button
                                className="btn"
                                onClick={() => {
                                  startEditing(candiateDetails);
                                  setIsEditing(true);
                                  setEditingId(candidateId);
                                }}
                                style={{
                                  borderRadius: "50%",
                                  fontSize: "18px",
                                  padding: "4px",
                                  lineHeight: 1,
                                }}
                              >
                                <HiPencilAlt style={{ color: "#1b56ae" }} />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className={`${Candidatedetailstyle.Createdon}`}>
                          Created on :{" "}
                          <DDMMYYYY_formate
                            dateValue={candiateDetails.createdTime}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col">
                      {" "}
                      
                    </div> */}
                    <div className={`col-sm-8`}>
                      <div className="row">
                        <div className="col-sm-4">
                          {/* <div
                            className={`${Candidatedetailstyle.verticalLine}`}
                          ></div> */}
                          <div
                            className={`${Candidatedetailstyle.CandidatepastDetails}`}
                          >
                            <div className="p-2">
                              {" "}
                              {/* {candiateDetails.pipelineStage != null
                                ? candiateDetails.pipelineStage
                                : "-"} */}
                              {/* {getPipelineStage(candiateDetails, currentDate)}{" "} */}
                              {noDataMessage ? (
                                <p>{noDataMessage}</p>
                              ) : (
                                <div>
                                  <b>Pipeline:</b>{" "}
                                  {candiateDetails.pipelineStage} <br />
                                  <div style={{ marginTop: "10px" }}>
                                    <b>Stage:</b> {stage}
                                  </div>
                                </div>
                              )}
                              <div className="mt-2 mb-2">
                                <b>Assigned To:</b>{" "}
                                {isSuperAdmin ||
                                candidateAdmin === 30 ||
                                teamLeader == "true"
                                  ? adminDetails.adminName &&
                                    adminDetails.id &&
                                    adminDetails.adminName[
                                      adminDetails.id.indexOf(
                                        candiateDetails.assignTo
                                      )
                                    ]
                                  : adminDetails.adminName &&
                                    adminDetails.id &&
                                    adminDetails.adminName[
                                      adminDetails.id.indexOf(
                                        candiateDetails.assignTo
                                      )
                                    ]}
                                {/* {candidateAdmin === 30 && "hi"} */}
                              </div>
                              {candiateDetails.joinedConfirmedAt != null && (
                                <>
                                  <b>Joined Date : </b>{" "}
                                  {dateFormateDD(
                                    candiateDetails.joinedConfirmedAt
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-8 ">
                          <div className={`row `}>
                            {/* ${Candidatedetailstyle.flexContainer} */}
                            {(parseInt(adminId) === candiateDetails.assignTo ||
                              isSuperAdmin) && (
                              <div
                                className={`col-sm-12 ${Candidatedetailstyle.flexContainer}`}
                              >
                                {/* <a
                                href={`https://www.taizo.in/waNotifications/customCandidateupdate.html?id=${candiateDetails.id}&adminId=${adminId}`}
                                target="_blank"
                                // className="nav-link"
                                style={{
                                  textDecoration: "none",
                                  color: "black",
                                }}
                                rel="noreferrer"
                              > */}
                                {isSuperAdmin && (
                                  <div
                                    className={`${Candidatedetailstyle.LiaUserEditSolid}`}
                                    onClick={() => {
                                      setdeleteCandidate(true);
                                    }}
                                  >
                                    <DeleteOutline />
                                  </div>
                                )}
                                <div
                                  className={`${Candidatedetailstyle.LiaUserEditSolid}`}
                                  onClick={() => {
                                    setopenCallReaminder(true);
                                  }}
                                >
                                  <div className="mb-1">
                                    {" "}
                                    <MdNotificationAdd className="fs-5" />
                                  </div>
                                </div>
                                <div
                                  className={`${Candidatedetailstyle.LiaUserEditSolid}`}
                                  onClick={handleopenCandidateUpdate}
                                >
                                  <div className="mb-1">
                                    {" "}
                                    <LiaUserEditSolid />
                                  </div>
                                </div>
                                {/* </a> */}

                                <div
                                  className={`${Candidatedetailstyle.LiaUserEditSolid}`}
                                >
                                  <div
                                    className="mb-1"
                                    onClick={() =>
                                      handleWhatsAppIconClick(
                                        candiateDetails.whatsappNumber
                                      )
                                    }
                                  >
                                    <FaWhatsapp />
                                  </div>
                                </div>
                                <div>
                                  {" "}
                                  {(dateFormateDD(
                                    selectedDate.tentativeInterviewDate
                                  ) == dateFormateDD(TodayDateCal) ||
                                    dateFormateDD(
                                      selectedDate.tentativeInterviewDate
                                    ) == dateFormateDD(tomorrowDateCal)) &&
                                    showScheduleInterview &&
                                    candiateDetails.id && (
                                      <div
                                        className={`${Candidatedetailstyle.scheduleinterview}`}
                                        style={{
                                          cursor: "pointer",
                                          zIndex: 2000,
                                        }}
                                      >
                                        <SlCalender className="me-2" />
                                        &nbsp;
                                        <ScheduleInterview
                                          interviewDate={
                                            selectedDate.tentativeInterviewDate
                                          }
                                          candidateId={candiateDetails.id}
                                          relationName={
                                            candiateDetails.relationName
                                          }
                                          relationType={
                                            candiateDetails.relationshipType
                                          }
                                          relationNumber={
                                            candiateDetails.emergencyContactNumber
                                          }
                                          onClose={handleEmptyDate}
                                          showPopup={true}
                                        />
                                      </div>
                                    )}
                                </div>
                                <div>
                                  {!followUpDateopenupdate &&
                                    !followUpDateopen &&
                                    (candiateDetails.tentativeInterviewDate !=
                                      null ||
                                      candiateDetails.interviewDate != null) &&
                                    showScheduleInterview &&
                                    candiateDetails.id && (
                                      <div
                                        className={`${Candidatedetailstyle.scheduleinterview}`}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <SlCalender className="me-2" />
                                        &nbsp;
                                        <ScheduleInterview
                                          candidateId={candiateDetails.id}
                                          relationName={
                                            candiateDetails.relationName
                                          }
                                          relationType={
                                            candiateDetails.relationshipType
                                          }
                                          relationNumber={
                                            candiateDetails.emergencyContactNumber
                                          }
                                          showPopup={false}
                                          onClose={handleEmptyDate}
                                        />
                                      </div>
                                    )}
                                </div>
                                <div>
                                  {candiateDetails.tentativeInterviewDate ===
                                    null && (
                                    <div
                                      className="btn btn-primary "
                                      onClick={() => {
                                        setfollowUpDateopen(true);
                                      }}
                                    >
                                      Tentative&nbsp;Date
                                    </div>
                                  )}{" "}
                                </div>
                                {candiateDetails.joiningTentativeDate != null &&
                                  showInterviewdateupdate &&
                                  candiateDetails.id && (
                                    <div
                                      className="btn btn-primary "
                                      onClick={() => {
                                        setJoiningFollowupdateupdate(true);
                                      }}
                                    >
                                      Update&nbsp;Joining&nbsp;Date
                                    </div>
                                  )}

                                {candiateDetails.tentativeInterviewDate !=
                                  null &&
                                  candiateDetails.joiningTentativeDate ===
                                    null &&
                                  showInterviewdateupdate &&
                                  candiateDetails.id && (
                                    <div
                                      className="btn btn-primary "
                                      onClick={() => {
                                        setfollowUpDateopenupdate(true);
                                      }}
                                    >
                                      Update&nbsp;Tentative&nbsp;Date
                                    </div>
                                  )}
                                {candiateDetails.tentativeInterviewDate !=
                                  null && (
                                  <div class="btn-group">
                                    <button
                                      type="button"
                                      // class="btn btn-secondary"
                                      data-bs-toggle="dropdown"
                                      data-bs-display="static"
                                      aria-expanded="false"
                                      style={{ border: "none" }}
                                      className={`${Candidatedetailstyle.ThreeOutline}`}
                                    >
                                      <PiDotsThreeOutlineVerticalFill />
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end dropdown-menu-lg-end">
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          type="button"
                                        >
                                          {showInterviewdateupdate &&
                                            candiateDetails.id && (
                                              <div
                                                // className="btn btn-primary "
                                                onClick={() => {
                                                  setfollowUpDateopenupdate(
                                                    true
                                                  );
                                                }}
                                              >
                                                <GoDotFill
                                                  style={{
                                                    color: "#BBF7D0",
                                                    fontSize: 20,
                                                  }}
                                                />{" "}
                                                Tentative Date{" "}
                                                {/* <GrDocumentUpdate /> */}
                                              </div>
                                            )}
                                        </button>
                                        <button
                                          className="dropdown-item"
                                          type="button"
                                        >
                                          {showInterviewdateupdate &&
                                            candiateDetails.id && (
                                              <div
                                                // className="btn btn-primary "
                                                onClick={() => {
                                                  setJoiningFollowupdateupdate(
                                                    true
                                                  );
                                                }}
                                              >
                                                <GoDotFill
                                                  style={{
                                                    color: "#BBF7D0",
                                                    fontSize: 20,
                                                  }}
                                                />{" "}
                                                Joining Date{" "}
                                                {/* <GrDocumentUpdate /> */}
                                              </div>
                                            )}
                                        </button>
                                      </li>
                                      {/* <li>
                                    <button class="dropdown-item" type="button">
                                      <MdCall /> +91{" "}
                                      {candiateDetails.mobileNumber}{" "}
                                      <MdOutlineContentCopy
                                        onClick={() =>
                                          handleCopyNumber(
                                            candiateDetails.mobileNumber
                                          )
                                        }
                                        className="ms-5"
                                      />
                                    </button>
                                  </li> */}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            )}
                            {!followUpDateopenupdate &&
                              !followUpDateopen &&
                              (candiateDetails.tentativeInterviewDate != null ||
                                candiateDetails.interviewDate != null) &&
                              showScheduleInterview &&
                              isSuperAdmin &&
                              candiateDetails.id && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "right",
                                    marginTop: "10px",
                                    paddingRight: "60px", // Adds spacing above if needed
                                  }}
                                >
                                  <div
                                    className="btn btn-danger"
                                    onClick={() => {
                                      setoponResetCandidate(true);
                                    }}
                                    style={{
                                      padding: "8px 16px",
                                      fontSize: "14px",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Reset
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2 px-4 ">
                    <div
                      className={`col-sm-4 pb-4 rounded  ${Candidatedetailstyle.personalDetails}`}
                      style={{ position: "relative" }}
                    >
                      <div style={{ position: "sticky", top: "0px" }}>
                        <div
                          className={`tab-buttons ${candidateTabsviewStyle.tab_buttons}`}
                          // style={{ backgroundColor: "gray" ,color:"#fff",cursor:"pointer"}}
                        >
                          <div
                            className={`d-flex ${candidateTabsviewStyle.tab_hr}`}
                          >
                            <div
                              onClick={() => handlepersonalTabClick(1)}
                              className={` ${
                                detailsactiveTab === 1
                                  ? candidateTabsviewStyle.activetag
                                  : candidateTabsviewStyle.unactivetag
                              } `}
                            >
                              Basic Details
                            </div>
                            <div
                              onClick={() => handlepersonalTabClick(2)}
                              className={` ${
                                detailsactiveTab === 2
                                  ? candidateTabsviewStyle.activetag
                                  : candidateTabsviewStyle.unactivetag
                              }`}
                            >
                              Qualify Form Details
                            </div>
                          </div>
                          <hr style={{ borderTop: "10px solid #ccc" }} />
                        </div>
                      </div>

                      <div
                        className={`tab-content ${candidateTabsviewStyle.tab_content} ${Candidatedetailstyle.scolltabs} `}
                        style={{ height: "80vh", overflow: "auto" }}
                      >
                        {candiateDetails.id && detailsactiveTab === 1 && (
                          <>
                            <div className="mt-2">
                              <h6>
                                <b>Admin Details</b>
                              </h6>
                              <div
                                className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                              >
                                <div className="col-5">
                                  <div style={{ lineHeight: "2" }}>
                                    Assigned To
                                  </div>
                                </div>
                                {isSuperAdmin && (
                                  <div className="col-7">
                                    <div>
                                      <Autocomplete
                                        id="clear-on-escape"
                                        clearOnEscape
                                        onChange={(event, newValue) => {
                                          if (newValue) {
                                            const selectedAdminName = newValue;
                                            if (
                                              adminDetails?.adminName &&
                                              adminDetails?.id &&
                                              typeof adminDetails.adminName
                                                .indexOf === "function" &&
                                              typeof adminDetails.id.indexOf ===
                                                "function"
                                            ) {
                                              const adminNameIndex =
                                                adminDetails.adminName.indexOf(
                                                  selectedAdminName
                                                );
                                              if (
                                                adminNameIndex !== -1 &&
                                                adminDetails.id[
                                                  adminNameIndex
                                                ] !== undefined
                                              ) {
                                                const adminId =
                                                  adminDetails.id[
                                                    adminNameIndex
                                                  ];
                                                handleLeadAssignfromAdmin(
                                                  candiateDetails.id,
                                                  adminId
                                                );
                                              } else {
                                                console.error(
                                                  `Admin with name ${selectedAdminName} not found.`
                                                );
                                              }
                                            } else {
                                              console.error(
                                                "Invalid adminDetails structure"
                                              );
                                            }
                                          }
                                        }}
                                        value={
                                          adminDetails?.adminName &&
                                          adminDetails?.id &&
                                          adminDetails.adminName[
                                            adminDetails.id.indexOf(
                                              candiateDetails.assignTo
                                            )
                                          ]
                                        }
                                        options={adminDetails.adminName}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Assign to"
                                            variant="standard"
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                )}
                                {!isSuperAdmin && (
                                  <>
                                    <div className="col-7">
                                      {/* {candidateAdmin === 30 ||
                                      teamLeader == "true"
                                        ? adminDetails.adminName &&
                                          adminDetails.id &&
                                          adminDetails.adminName[
                                            adminDetails.id.indexOf(
                                              candiateDetails.assignTo
                                            )
                                          ]
                                        : adminuserName} */}
                                      {adminDetails.adminName &&
                                        adminDetails.id &&
                                        adminDetails.adminName[
                                          adminDetails.id.indexOf(
                                            candiateDetails.assignTo
                                          )
                                        ]}
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>{" "}
                            <div className="mt-2">
                              {" "}
                              <h6>
                                <b>Personal Details</b>
                              </h6>
                              <div
                                className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                              >
                                <div className="col-5">
                                  <div style={{ lineHeight: "2" }}>Name </div>
                                  <div style={{ lineHeight: "2" }}>Gender</div>
                                  <div style={{ lineHeight: "2" }}>
                                    Date Of Birth
                                  </div>
                                  {/* <div style={{ lineHeight: "2" }}>
                                    Current Location
                                  </div> */}

                                  <div style={{ lineHeight: "2" }}>
                                    Mobile Number
                                  </div>
                                  <div style={{ lineHeight: "2.5" }}>
                                    Whatsapp Number
                                  </div>
                                  {/* <div style={{ lineHeight: "2.3" }}>
                                    Relationship type
                                  </div> */}
                                  <div style={{ lineHeight: "2" }}>
                                    Relation Name
                                  </div>
                                  <div style={{ lineHeight: "2.5" }}>
                                    Emergency Contact
                                  </div>
                                </div>
                                <div className="col-7">
                                  <div style={{ lineHeight: "2" }}>
                                    {" "}
                                    {candiateDetails.firstName != null
                                      ? capitalizeWords(
                                          candiateDetails.firstName
                                        ) +
                                        " " +
                                        (candiateDetails.lastName != null
                                          ? capitalizeWords(
                                              candiateDetails.lastName
                                            ) + ""
                                          : "")
                                      : "-"}
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.gender != null
                                      ? candiateDetails.gender
                                      : "-"}
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.dateOfBirth != null
                                      ? candiateDetails.dateOfBirth
                                      : "-"}
                                  </div>
                                  {/* <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.currentCity != null
                                      ? candiateDetails.currentCity
                                      : "-"}{" "}
                                    ,{" "}
                                    {candiateDetails.currentState != null
                                      ? candiateDetails.currentState
                                      : "-"}
                                  </div> */}

                                  <div
                                    className="d-flex "
                                    style={{ lineHeight: "2" }}
                                  >
                                    <div
                                      className={`me-3 ${Candidatedetailstyle.numbersstyle}`}
                                    >
                                      <img src={flag} alt="" width={15} />{" "}
                                      <span>
                                        {candiateDetails.mobileNumber}{" "}
                                      </span>
                                      <MdOutlineContentCopy
                                        onClick={() =>
                                          handleCopyNumber(
                                            candiateDetails.mobileNumber
                                          )
                                        }
                                      />
                                    </div>
                                    <div
                                      className={`${Candidatedetailstyle.Phonecall}`}
                                    >
                                      <MdCall />
                                    </div>
                                  </div>

                                  <div
                                    className="d-flex"
                                    style={{ lineHeight: "2" }}
                                  >
                                    <div
                                      className={`me-3 ${Candidatedetailstyle.Whatsapnumbersstyle}`}
                                    >
                                      <img
                                        src={WhatsappImage}
                                        alt=""
                                        width={16}
                                      />{" "}
                                      <span>
                                        {candiateDetails.whatsappNumber}{" "}
                                      </span>
                                      <MdOutlineContentCopy
                                        onClick={() =>
                                          handleCopyNumber(
                                            candiateDetails.whatsappNumber
                                          )
                                        }
                                      />
                                    </div>

                                    <div
                                      className={`${Candidatedetailstyle.Phonecall}`}
                                    >
                                      <FaWhatsapp
                                        onClick={() =>
                                          handleWhatsAppIconClick(
                                            candiateDetails.whatsappNumber
                                          )
                                        }
                                      />
                                    </div>
                                    {/* <div
                                className={`${Candidatedetailstyle.Phonecall}`}
                              > */}

                                    {/* </div> */}
                                  </div>

                                  {/* <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.relationshipType != null
                                      ? candiateDetails.relationshipType
                                      : "-"}
                                  </div> */}
                                  <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.relationName != null
                                      ? candiateDetails.relationName
                                      : "-"}
                                  </div>
                                  <div
                                    className="d-flex"
                                    style={{ lineHeight: "2" }}
                                  >
                                    <div
                                      className={`me-3 ${Candidatedetailstyle.Whatsapnumbersstyle}`}
                                    >
                                      <img src={flag} alt="" width={16} />{" "}
                                      <span>
                                        {candiateDetails.emergencyContactNumber}
                                      </span>
                                      <MdOutlineContentCopy
                                        onClick={() =>
                                          handleCopyNumber(
                                            candiateDetails.emergencyContactNumber
                                          )
                                        }
                                      />
                                    </div>

                                    <div
                                      className={`${Candidatedetailstyle.Phonecall}`}
                                    >
                                      <MdCall />
                                    </div>
                                    {/* <div
                                className={`${Candidatedetailstyle.Phonecall}`}
                              > */}

                                    {/* </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="mt-2">
                              <h6>
                                <b>Education Details</b>
                              </h6>
                              <div
                                className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                              >
                                <div className="col-5">
                                  <div style={{ lineHeight: "2" }}>
                                    {" "}
                                    Qualification
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    Degree/Specialization
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    Completed Year
                                  </div>
                                </div>
                                <div className="col-7">
                                  {" "}
                                  <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.qualification != null
                                      ? candiateDetails.qualification
                                      : "-"}{" "}
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.specification != null
                                      ? candiateDetails.specification
                                      : "-"}
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.passed_out_year != null
                                      ? candiateDetails.passed_out_year
                                      : "-"}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <div className="mt-2">
                              <h6>
                                <b>Work Details</b>
                              </h6>
                              <div
                                className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                              >
                                <div className="col-5">
                                  <div style={{ lineHeight: "2" }}>
                                    Job Category{" "}
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    Industry
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    Experience
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    Preferred Job City
                                  </div>
                                  
                                </div>
                                <div className="col-7">
                                  <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.jobCategory != null
                                      ? candiateDetails.jobCategory
                                      : "-"}{" "}
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.industry != null
                                      ? candiateDetails.industry
                                      : "-"}
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.experience != null
                                      ? candiateDetails.experience
                                      : "-"}
                                  </div>
                                  <div style={{ lineHeight: "2" }}>
                                    {candiateDetails.city != null
                                      ? candiateDetails.city
                                      : "-"}
                                  </div>
                                  
                                </div>
                              </div>
                            </div> */}
                            <div className="mt-2">
                              <h6>
                                <b>Other Details</b>
                              </h6>
                              <div
                                className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                              >
                                <div className="col-5">
                                  <div>
                                    <b>Key Skills</b>
                                  </div>
                                </div>
                                <div className="mt-3">
                                  <div>
                                    <div>
                                      {/* {candiateDetails.keySkill} */}
                                      <div
                                        className={`${Candidatedetailstyle.keySkillsContainer}`}
                                      >
                                        {" "}
                                        {/* Add a container */}
                                        {keySkillsArray.map((skill, index) =>
                                          skill && typeof skill === "string" ? (
                                            <div
                                              className={`${Candidatedetailstyle.KeySkills}`}
                                              key={index}
                                            >
                                              {skill.trim()}
                                            </div>
                                          ) : null
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                              >
                                {candiateDetails.certificationCourses !=
                                  null && (
                                  <>
                                    {" "}
                                    <div className="col-5">
                                      <div>
                                        <b>Certification</b>
                                      </div>
                                    </div>
                                    <div className="mt-3">
                                      <div>
                                        <div>
                                          {/* {candiateDetails.keySkill} */}
                                          <div
                                            className={`${Candidatedetailstyle.keySkillsContainer}`}
                                          >
                                            {certificationArray.map(
                                              (course, index) =>
                                                course &&
                                                typeof course === "string" ? (
                                                  <div
                                                    className={`${Candidatedetailstyle.KeySkills}`}
                                                    key={index}
                                                  >
                                                    {course.trim()}
                                                  </div>
                                                ) : null
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </>
                        )}

                        {/* // <React.Fragment key={index}> */}
                        {(candiateDetails.candidateType !== "Experienced" ||
                          candiateDetails.experienced === null) &&
                          candiateDetails.id &&
                          detailsactiveTab === 2 && (
                            <>
                              {candiateDetails.joiningTentativeDate === null ? (
                                <div className="mt-2">
                                  <h6>
                                    <b>Follow up Status</b>
                                  </h6>
                                  {/* <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      <div>Suggested Company Details </div>
                                    </div>
                                    <div className="col-7">
                                      <div>
                                        {candiateDetails.suggestedCompanyName !=
                                        null
                                          ? (() => {
                                              try {
                                                const suggestedDetails =
                                                  JSON.parse(
                                                    candiateDetails.suggestedCompanyName
                                                  );
                                                return `${suggestedDetails.companyName} (${suggestedDetails.area} , ${suggestedDetails.city})`;
                                              } catch (error) {
                                                console.error(
                                                  "Error parsing JSON",
                                                  error
                                                );
                                                return "-";
                                              }
                                            })()
                                          : "-"}
                                      </div>
                                    </div>
                                  </div> */}
                                  <div
                                    className={
                                      Candidatedetailstyle.CanDetailsRow
                                    }
                                  >
                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Suggested Company
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.suggestedCompanyName
                                          ? (() => {
                                              try {
                                                const s = JSON.parse(
                                                  candiateDetails.suggestedCompanyName
                                                );
                                                return s.companyName;
                                              } catch {
                                                return "-";
                                              }
                                            })()
                                          : "-"}
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Suggested Location
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.suggestedCompanyName
                                          ? (() => {
                                              try {
                                                const s = JSON.parse(
                                                  candiateDetails.suggestedCompanyName
                                                );
                                                return `${s.area}, ${s.city}`;
                                              } catch {
                                                return "-";
                                              }
                                            })()
                                          : "-"}
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Suggested Job Category
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.suggestedJobcategory ??
                                          "-"}
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Interview Date
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.tentativeInterviewDate
                                          ? `${dateFormateDD(
                                              candiateDetails.tentativeInterviewDate
                                            )} (Tentative)`
                                          : "-"}
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Follow up 1
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.followUpDate1
                                          ? dateFormateDD(
                                              candiateDetails.followUpDate1
                                            )
                                          : "-"}
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Follow up 2
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.followUpDate2
                                          ? dateFormateDD(
                                              candiateDetails.followUpDate2
                                            )
                                          : "-"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="mt-2">
                                  <h6>
                                    <b>Joining Follow up Status</b>
                                  </h6>
                                  <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      {/* <div style={{ lineHeight: "2" }}>
                                      Suggested Company{" "}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Suggested Job Category{" "}
                                    </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        Joining Date
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Follow up 1
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Follow up 2
                                      </div>
                                    </div>
                                    <div className="col-7">
                                      {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.suggestedCompanyName !=
                                      null
                                        ? candiateDetails.suggestedCompanyName
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.suggestedJobcategory !=
                                      null
                                        ? candiateDetails.suggestedJobcategory
                                        : "-"}
                                    </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.joiningTentativeDate !=
                                        null
                                          ? dateFormateDD(
                                              candiateDetails.joiningTentativeDate
                                            ) + "(tentative)"
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.joiningFollowUpDate1 !=
                                        null
                                          ? dateFormateDD(
                                              candiateDetails.joiningFollowUpDate1
                                            )
                                          : "-"}
                                      </div>
                                      {candiateDetails.joiningTentativeDate !=
                                      null ? (
                                        <div style={{ lineHeight: "2" }}>
                                          {candiateDetails.joiningFollowUpDate2 !=
                                          null
                                            ? dateFormateDD(
                                                candiateDetails.joiningFollowUpDate2
                                              )
                                            : "-"}
                                        </div>
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="mt-2">
                                <h6>
                                  <b>Job Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    <div style={{ lineHeight: "2" }}>
                                      Position applied for
                                    </div>
                                    <div style={{ lineHeight: "2" }}></div>
                                    <div style={{ lineHeight: "2" }}>
                                      Preferred job city
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Preferred job area
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Preferred job area
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Do we have job in this location?
                                    </div> */}
                                  </div>
                                  <div className="col-7">
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.jobCategory != null
                                        ? candiateDetails.jobCategory
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.prefLocation != null
                                        ? candiateDetails.prefLocation
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.prefArea != null
                                        ? candiateDetails.prefArea
                                        : "-"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.canSuitableJobLocation !=
                                            null
                                              ? capitalizeWords(
                                                  candiateDetails.canSuitableJobLocation
                                                )
                                              : "-"}
                                          </div> */}

                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.havingJobLocation != null
                                        ? candiateDetails.havingJobLocation
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2">
                                <h6>
                                  <b>Education Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Education
                                          </div>
                                          <div style={{ lineHeight: "2" }}>
                                            Specialization
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Mechanical related course ?
                                          </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      Any arrear?
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Is there a gap now after education?
                                    </div> */}
                                  </div>
                                  <div className="col-7">
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candidate.education != null
                                              ? candidate.education
                                              : "-"}
                                          </div>
                                          <div style={{ lineHeight: "2" }}>
                                            {candidate.specialization != null
                                              ? candidate.specialization
                                              : "-"}
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candidate.isMechanicalRelatedDegree !=
                                            null
                                              ? candidate.isMechanicalRelatedDegree
                                                ? "Yes"
                                                : "No"
                                              : "-"}
                                          </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.isHavingArrear === "Yes"
                                        ? "Yes"
                                        : "No"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.havingEducationalGap !=
                                      null
                                        ? candiateDetails.havingEducationalGap
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              {/* <div className="mt-2">
                                      <h6>
                                        <b>Expertise Details</b>
                                      </h6>
                                      <div
                                        className={`row ${candiateDetailsdetailstyle.CanDetailsRow}`}
                                      >
                                        <div className="col-7">
                                          <div style={{ lineHeight: "2" }}>
                                            Skills and Certifications
                                          </div>
                                        </div>
                                        <div className="col-5">
                                          <div style={{ lineHeight: "2" }}>
                                            {candidate.skillsCertifications !=
                                            null
                                              ? candidate.skillsCertifications
                                              : "-"}
                                          </div>
                                        </div>
                                      </div>
                                    </div> */}
                              <div className="mt-2">
                                <h6>
                                  <b>Background Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    <div style={{ lineHeight: "2" }}>
                                      Current stay location?
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Current stay type?
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Ready to relocate?
                                    </div> */}
                                  </div>
                                  <div className="col-7">
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.city != null
                                        ? capitalizeWords(candiateDetails.city)
                                        : "-"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candidate.currentStayType != null
                                              ? candidate.currentStayType
                                              : "-"}
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candidate.readyToRelocate !=
                                      null
                                        ? candidate.readyToRelocate
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2">
                                <h6>
                                  <b>Salary Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    <div style={{ lineHeight: "2" }}>
                                      Expected Salary?
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Current stay type?
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Ready to work for suggested salary ?
                                          </div> */}
                                  </div>
                                  <div className="col-7">
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.expectedSalary != null
                                        ? candiateDetails.expectedSalary
                                        : "-"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candidate.currentStayType != null
                                              ? candidate.currentStayType
                                              : "-"}
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candidate.workForSuggestedSalary !=
                                            null
                                              ? candidate.workForSuggestedSalary
                                              : "-"}
                                          </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2">
                                <h6>
                                  <b>Other Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    <div style={{ lineHeight: "2" }}>
                                      Rotational shifts?
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Accomodation needed?
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Transport needed?
                                    </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Updated CV/Resume?
                                    </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Reference
                                    </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Immediate Joiner
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Notice Peroid
                                    </div> */}
                                    <div style={{ lineHeight: "2" }}>Notes</div>
                                  </div>
                                  <div className="col-7">
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.readyForShifts != null
                                        ? candiateDetails.readyForShifts
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.needAccommodation != null
                                        ? candiateDetails.needAccommodation
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.needTransport !=
                                      null
                                        ? candiateDetails.needTransport
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.havingUpdatedCv
                                        ? "Yes"
                                        : "No"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.reference != null
                                        ? candiateDetails.reference
                                        : "-"}
                                    </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.immediateJoiner != null
                                              ? candiateDetails.immediateJoiner
                                                ? "Yes"
                                                : "No"
                                              : "-"}
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.noticePeriod != null
                                        ? candiateDetails.noticePeriod
                                        : "-"}
                                    </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.notes != null
                                        ? candiateDetails.notes
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                        {
                          // candidate.experienced &&
                          candiateDetails.candidateType === "Experienced" &&
                            // candiateDetails.currentlyWorking &&
                            candiateDetails.currentlyworking === "Yes" &&
                            candiateDetails.id &&
                            detailsactiveTab === 2 && (
                              <>
                                {candiateDetails.joiningTentativeDate ===
                                null ? (
                                  <div className="mt-2">
                                    <h6>
                                      <b>Follow up Status</b>
                                    </h6>
                                    <div
                                      className={
                                        Candidatedetailstyle.CanDetailsRow
                                      }
                                    >
                                      <div className="row mb-2">
                                        <div className="col-5 fw-semibold">
                                          Suggested Company
                                        </div>
                                        <div className="col-7">
                                          {candiateDetails.suggestedCompanyName
                                            ? (() => {
                                                try {
                                                  const s = JSON.parse(
                                                    candiateDetails.suggestedCompanyName
                                                  );
                                                  return s.companyName;
                                                } catch {
                                                  return "-";
                                                }
                                              })()
                                            : "-"}
                                        </div>
                                      </div>

                                      <div className="row mb-2">
                                        <div className="col-5 fw-semibold">
                                          Suggested Location
                                        </div>
                                        <div className="col-7">
                                          {candiateDetails.suggestedCompanyName
                                            ? (() => {
                                                try {
                                                  const s = JSON.parse(
                                                    candiateDetails.suggestedCompanyName
                                                  );
                                                  return `${s.area}, ${s.city}`;
                                                } catch {
                                                  return "-";
                                                }
                                              })()
                                            : "-"}
                                        </div>
                                      </div>

                                      <div className="row mb-2">
                                        <div className="col-5 fw-semibold">
                                          Suggested Job Category
                                        </div>
                                        <div className="col-7">
                                          {candiateDetails.suggestedJobcategory ??
                                            "-"}
                                        </div>
                                      </div>

                                      <div className="row mb-2">
                                        <div className="col-5 fw-semibold">
                                          Interview Date
                                        </div>
                                        <div className="col-7">
                                          {candiateDetails.tentativeInterviewDate
                                            ? `${dateFormateDD(
                                                candiateDetails.tentativeInterviewDate
                                              )} (Tentative)`
                                            : "-"}
                                        </div>
                                      </div>

                                      <div className="row mb-2">
                                        <div className="col-5 fw-semibold">
                                          Follow up 1
                                        </div>
                                        <div className="col-7">
                                          {candiateDetails.followUpDate1
                                            ? dateFormateDD(
                                                candiateDetails.followUpDate1
                                              )
                                            : "-"}
                                        </div>
                                      </div>

                                      <div className="row mb-2">
                                        <div className="col-5 fw-semibold">
                                          Follow up 2
                                        </div>
                                        <div className="col-7">
                                          {candiateDetails.followUpDate2
                                            ? dateFormateDD(
                                                candiateDetails.followUpDate2
                                              )
                                            : "-"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="mt-2">
                                    <h6>
                                      <b>Joining Follow up Status</b>
                                    </h6>
                                    <div
                                      className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                    >
                                      <div className="col-5">
                                        {/* <div style={{ lineHeight: "2" }}>
                                      Suggested Company{" "}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Suggested Job Category{" "}
                                    </div> */}
                                        <div style={{ lineHeight: "2" }}>
                                          Joining Date
                                        </div>
                                        <div style={{ lineHeight: "2" }}>
                                          Follow up 1
                                        </div>
                                        <div style={{ lineHeight: "2" }}>
                                          Follow up 2
                                        </div>
                                      </div>
                                      <div className="col-7">
                                        {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.suggestedCompanyName !=
                                      null
                                        ? candiateDetails.suggestedCompanyName
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.suggestedJobcategory !=
                                      null
                                        ? candiateDetails.suggestedJobcategory
                                        : "-"}
                                    </div> */}
                                        <div style={{ lineHeight: "2" }}>
                                          {candiateDetails.joiningTentativeDate !=
                                          null
                                            ? dateFormateDD(
                                                candiateDetails.joiningTentativeDate
                                              ) + "(tentative)"
                                            : "-"}
                                        </div>
                                        <div style={{ lineHeight: "2" }}>
                                          {candiateDetails.joiningFollowUpDate1 !=
                                          null
                                            ? dateFormateDD(
                                                candiateDetails.joiningFollowUpDate1
                                              )
                                            : "-"}
                                        </div>
                                        {candiateDetails.joiningTentativeDate !=
                                        null ? (
                                          <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.joiningFollowUpDate2 !=
                                            null
                                              ? dateFormateDD(
                                                  candiateDetails.joiningFollowUpDate2
                                                )
                                              : "-"}
                                          </div>
                                        ) : (
                                          "-"
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <div className="mt-2">
                                  <h6>
                                    <b>Current Status</b>
                                  </h6>
                                  <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      <div style={{ lineHeight: "2" }}>
                                        Reason for jobchange
                                      </div>
                                    </div>
                                    <div className="col-7">
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.reason_for_jobchange !=
                                        null
                                          ? candiateDetails.reason_for_jobchange
                                          : "-"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-2">
                                  <h6>
                                    <b>Job Details</b>
                                  </h6>
                                  <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      <div style={{ lineHeight: "2" }}>
                                        Position applied for
                                      </div>
                                      <div style={{ lineHeight: "2" }}></div>
                                      <div style={{ lineHeight: "2" }}>
                                        Preferred job city
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Preferred job area
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                            Preferred job area
                                          </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                        Do we have job in this location?
                                      </div> */}
                                    </div>
                                    <div className="col-7">
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.jobCategory != null
                                          ? candiateDetails.jobCategory
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.prefLocation != null
                                          ? candiateDetails.prefLocation
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.prefArea != null
                                          ? candiateDetails.prefArea
                                          : "-"}
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.havingJobLocation !=
                                        null
                                          ? candiateDetails.havingJobLocation
                                            ? "Yes"
                                            : "No"
                                          : "-"}
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-2">
                                  <h6>
                                    <b>Education Details</b>
                                  </h6>
                                  <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      {/* <div style={{ lineHeight: "2" }}>
                                              Education
                                            </div>
                                            <div style={{ lineHeight: "2" }}>
                                              Specialization
                                            </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                              Mechanical related course?
                                            </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        Any arrear?
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                      Is there a gap now after education?
                                    </div> */}
                                    </div>
                                    <div className="col-7">
                                      {/* <div style={{ lineHeight: "2" }}>
                                              {candidate.education != null
                                                ? candidate.education
                                                : "-"}
                                            </div>
                                            <div style={{ lineHeight: "2" }}>
                                              {candidate.specialization != null
                                                ? candidate.specialization
                                                : "-"}
                                            </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                              {candidate.isMechanicalRelatedDegree !=
                                              null
                                                ? candidate.isMechanicalRelatedDegree
                                                  ? "Yes"
                                                  : "No"
                                                : "-"}
                                            </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.isHavingArrear ===
                                        "Yes"
                                          ? "Yes"
                                          : "No"}
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                      {candidate.havingEducationalGap !=
                                      null
                                        ? candidate.havingEducationalGap
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-2">
                                  <h6>
                                    <b>Experience Details</b>
                                  </h6>
                                  <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      {/* <div style={{ lineHeight: "2" }}>
                                        Current position name?
                                      </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        Current industry?
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Experience in years
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Experience in Months
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                        long work gap?
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Exp. for same industry & job category?
                                      </div> */}
                                    </div>
                                    <div className="col-7">
                                      {/* <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.jobrole != null
                                          ? candiateDetails.jobrole
                                          : "-"}
                                      </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.industry != null
                                          ? candiateDetails.industry
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.experience != null
                                          ? candiateDetails.experience +
                                            " " +
                                            "year(s)"
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.expMonths != null
                                          ? candiateDetails.expMonths +
                                            " " +
                                            "month(s)"
                                          : "-"}
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.havingWorkGap != null
                                          ? candiateDetails.havingWorkGap
                                            ? "Yes"
                                            : "No"
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.overallExperience !=
                                        null
                                          ? candiateDetails.overallExperience
                                            ? "Yes"
                                            : "No"
                                          : "-"}
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="mt-2">
                                      <h6>
                                        <b>Expertise Details</b>
                                      </h6>
                                      <div
                                        className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                      >
                                        <div className="col-5">
                                          <div style={{ lineHeight: "2" }}>
                                            Skills and Certifications
                                          </div>
                                        </div>
                                        <div className="col-7">
                                          <div style={{ lineHeight: "2" }}>
                                            {candidate.skillsCertifications !=
                                            null
                                              ? candidate.skillsCertifications
                                              : "-"}
                                          </div>
                                        </div>
                                      </div>
                                    </div> */}
                                <div className="mt-2">
                                  <h6>
                                    <b>Current Work Details</b>
                                  </h6>
                                  <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      <div style={{ lineHeight: "2" }}>
                                        Current company name
                                      </div>

                                      <div style={{ lineHeight: "2" }}>
                                        Company location
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Current job type
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Current work hours
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Notice Period
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                              Immediate Joiner
                                            </div> */}
                                    </div>
                                    <div className="col-7">
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.companyName != null
                                          ? candiateDetails.companyName
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.companyLocation != null
                                          ? candiateDetails.companyLocation
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.jobType != null
                                          ? candiateDetails.jobType
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.jobWorkHours != null
                                          ? candiateDetails.jobWorkHours
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.noticePeriod != null
                                          ? candiateDetails.noticePeriod
                                          : "-"}
                                      </div>

                                      {/* <div style={{ lineHeight: "2" }}>
                                              {candidate.immediateJoiner != null
                                                ? candidate.immediateJoiner
                                                  ? "Yes"
                                                  : "No"
                                                : "-"}
                                            </div> */}
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-2">
                                  <h6>
                                    <b>Background Details</b>
                                  </h6>
                                  <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      <div style={{ lineHeight: "2" }}>
                                        Current stay location?
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                              Current stay type?
                                            </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                      Ready to relocate?
                                    </div> */}
                                    </div>
                                    <div className="col-7">
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.city != null
                                          ? candiateDetails.city
                                          : "-"}
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                              {candidate.currentStayType != null
                                                ? candidate.currentStayType
                                                : "-"}
                                            </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                      {candidate.readyToRelocate !=
                                      null
                                        ? candidate.readyToRelocate
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-2">
                                  <h6>
                                    <b>Current Salary Details</b>
                                  </h6>
                                  <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      {/* <div style={{ lineHeight: "2" }}>
                                        current salary?
                                      </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        Take home salary?
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Expected salary?
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                        Salary Document?
                                      </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                              Current stay type?
                                            </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                              Ready to work for suggested salary
                                              ?
                                            </div> */}
                                    </div>
                                    <div className="col-7">
                                      {/* <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.adminSuggestedSalary !=
                                        null
                                          ? candiateDetails.adminSuggestedSalary
                                          : "-"}
                                      </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.takeHomeSalary != null
                                          ? candiateDetails.takeHomeSalary
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.expectedSalary != null
                                          ? candiateDetails.expectedSalary
                                          : "-"}
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.salaryProofDocumentType !=
                                        null
                                          ? candiateDetails.salaryProofDocumentType
                                          : "-"}
                                      </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                              {candiateDetails.currentStayType != null
                                                ? candiateDetails.currentStayType
                                                : "-"}
                                            </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                              {candiateDetails.workForSuggestedSalary !=
                                              null
                                                ? candiateDetails.workForSuggestedSalary
                                                : "-"}
                                            </div> */}
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-2">
                                  <h6>
                                    <b>Other Details</b>
                                  </h6>
                                  <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      <div style={{ lineHeight: "2" }}>
                                        Rotational shifts?
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Accomodation needed?
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                      Transport needed?
                                    </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                        Updated CV/Resume?
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Reference
                                      </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                              Immediate Joiner
                                            </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        Notice Peroid
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Notes
                                      </div>
                                    </div>
                                    <div className="col-7">
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.readyForShifts != null
                                          ? candiateDetails.readyForShifts
                                            ? "Yes"
                                            : "No"
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.needAccommodation !=
                                        null
                                          ? candiateDetails.needAccommodation
                                            ? "Yes"
                                            : "No"
                                          : "-"}
                                      </div>
                                      {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.needTransport !=
                                      null
                                        ? candiateDetails.needTransport
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.havingUpdatedCV
                                          ? "Yes"
                                          : "No"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.reference != null
                                          ? candiateDetails.reference
                                          : "-"}
                                      </div> */}
                                      {/* <div style={{ lineHeight: "2" }}>
                                              {candiateDetails.immediateJoiner != null
                                                ? candiateDetails.immediateJoiner
                                                  ? "Yes"
                                                  : "No"
                                                : "-"}
                                            </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.noticePeriod != null
                                          ? candiateDetails.noticePeriod
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.notes != null
                                          ? candiateDetails.notes
                                          : "-"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )
                        }

                        {candiateDetails.candidateType === "Experienced" &&
                          candiateDetails.currentlyworking === "No" &&
                          candiateDetails.id &&
                          detailsactiveTab === 2 && (
                            <>
                              {candiateDetails.joiningTentativeDate === null ? (
                                <div className="mt-2">
                                  <h6>
                                    <b>Follow up Status</b>
                                  </h6>
                                  <div
                                    className={
                                      Candidatedetailstyle.CanDetailsRow
                                    }
                                  >
                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Suggested Company
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.suggestedCompanyName
                                          ? (() => {
                                              try {
                                                const s = JSON.parse(
                                                  candiateDetails.suggestedCompanyName
                                                );
                                                return s.companyName;
                                              } catch {
                                                return "-";
                                              }
                                            })()
                                          : "-"}
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Suggested Location
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.suggestedCompanyName
                                          ? (() => {
                                              try {
                                                const s = JSON.parse(
                                                  candiateDetails.suggestedCompanyName
                                                );
                                                return `${s.area}, ${s.city}`;
                                              } catch {
                                                return "-";
                                              }
                                            })()
                                          : "-"}
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Suggested Job Category
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.suggestedJobcategory ??
                                          "-"}
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Interview Date
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.tentativeInterviewDate
                                          ? `${dateFormateDD(
                                              candiateDetails.tentativeInterviewDate
                                            )} (Tentative)`
                                          : "-"}
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Follow up 1
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.followUpDate1
                                          ? dateFormateDD(
                                              candiateDetails.followUpDate1
                                            )
                                          : "-"}
                                      </div>
                                    </div>

                                    <div className="row mb-2">
                                      <div className="col-5 fw-semibold">
                                        Follow up 2
                                      </div>
                                      <div className="col-7">
                                        {candiateDetails.followUpDate2
                                          ? dateFormateDD(
                                              candiateDetails.followUpDate2
                                            )
                                          : "-"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="mt-2">
                                  <h6>
                                    <b>Joining Follow up Status</b>
                                  </h6>
                                  <div
                                    className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                  >
                                    <div className="col-5">
                                      {/* <div style={{ lineHeight: "2" }}>
                                      Suggested Company{" "}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Suggested Job Category{" "}
                                    </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        Joining Date
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Follow up 1
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        Follow up 2
                                      </div>
                                    </div>
                                    <div className="col-7">
                                      {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.suggestedCompanyName !=
                                      null
                                        ? candiateDetails.suggestedCompanyName
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.suggestedJobcategory !=
                                      null
                                        ? candiateDetails.suggestedJobcategory
                                        : "-"}
                                    </div> */}
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.joiningTentativeDate !=
                                        null
                                          ? dateFormateDD(
                                              candiateDetails.joiningTentativeDate
                                            ) + "(tentative)"
                                          : "-"}
                                      </div>
                                      <div style={{ lineHeight: "2" }}>
                                        {candiateDetails.joiningFollowUpDate1 !=
                                        null
                                          ? dateFormateDD(
                                              candiateDetails.joiningFollowUpDate1
                                            )
                                          : "-"}
                                      </div>
                                      {candiateDetails.joiningTentativeDate !=
                                      null ? (
                                        <div style={{ lineHeight: "2" }}>
                                          {candiateDetails.joiningFollowUpDate2 !=
                                          null
                                            ? dateFormateDD(
                                                candiateDetails.joiningFollowUpDate2
                                              )
                                            : "-"}
                                        </div>
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="mt-2">
                                <h6>
                                  <b>Current Status</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    <div style={{ lineHeight: "2" }}>
                                      Reason for unemployment
                                    </div>
                                  </div>
                                  <div className="col-7">
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.reason_for_unemployment !=
                                      null
                                        ? candiateDetails.reason_for_unemployment
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2">
                                <h6>
                                  <b>Job Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    <div style={{ lineHeight: "2" }}>
                                      Position applied for
                                    </div>
                                    <div style={{ lineHeight: "2" }}></div>
                                    <div style={{ lineHeight: "2" }}>
                                      Preferred job city
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Preferred job area
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Preferred job area
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Do we have job in this location?
                                    </div> */}
                                  </div>
                                  <div className="col-7">
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.jobCategory != null
                                        ? candiateDetails.jobCategory
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.prefLocation != null
                                        ? candiateDetails.prefLocation
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.prefArea != null
                                        ? candiateDetails.prefArea
                                        : "-"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.havingJobLocation != null
                                        ? candiateDetails.havingJobLocation
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2">
                                <h6>
                                  <b>Education Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Education
                                          </div>
                                          <div style={{ lineHeight: "2" }}>
                                            Specialization
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Mechanical related course?
                                          </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      Any arrear?
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Is there a gap now after education?
                                    </div> */}
                                  </div>
                                  <div className="col-7">
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.education != null
                                              ? candiateDetails.education
                                              : "-"}
                                          </div>
                                          <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.specialization != null
                                              ? candiateDetails.specialization
                                              : "-"}
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.isMechanicalRelatedDegree !=
                                            null
                                              ? candiateDetails.isMechanicalRelatedDegree
                                                ? "Yes"
                                                : "No"
                                              : "-"}
                                          </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.isHavingArrear === "Yes"
                                        ? "Yes"
                                        : "No"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.havingEducationalGap !=
                                      null
                                        ? candiateDetails.havingEducationalGap
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2">
                                <h6>
                                  <b>Experience Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Previous position name
                                    </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      Previous industry
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Experience in years
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Experience in months
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      long work gap?
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Exp. for same industry and job category?
                                    </div> */}
                                  </div>
                                  <div className="col-7">
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.jobrole != null
                                        ? candiateDetails.jobrole
                                        : "-"}
                                    </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.industry != null
                                        ? candiateDetails.industry
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.experience != null
                                        ? candiateDetails.experience +
                                          " " +
                                          "year(s)"
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.expMonths != null
                                        ? candiateDetails.expMonths +
                                          " " +
                                          "month(s)"
                                        : "-"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.havingWorkGap != null
                                        ? candiateDetails.havingWorkGap
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.overallExperience != null
                                        ? candiateDetails.overallExperience
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              {/* <div className="mt-2">
                                      <h6>
                                        <b>Expertise Details</b>
                                      </h6>
                                      <div
                                        className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                      >
                                        <div className="col-5">
                                          <div style={{ lineHeight: "2" }}>
                                            Skills and Certifications
                                          </div>
                                        </div>
                                        <div className="col-7">
                                          <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.skillsCertifications !=
                                            null
                                              ? candiateDetails.skillsCertifications
                                              : "-"}
                                          </div>
                                        </div>
                                      </div>
                                    </div> */}
                              <div className="mt-2">
                                <h6>
                                  <b>Previous Work Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    <div style={{ lineHeight: "2" }}>
                                      Previous company name
                                    </div>

                                    <div style={{ lineHeight: "2" }}>
                                      Previous location
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Previous job type
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Previous work hours
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Notice Period
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Immediate Joiner
                                          </div> */}
                                  </div>
                                  <div className="col-7">
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.companyName != null
                                        ? candiateDetails.companyName
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.companyLocation != null
                                        ? candiateDetails.companyLocation
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.jobType != null
                                        ? candiateDetails.jobType
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.jobWorkHours != null
                                        ? candiateDetails.jobWorkHours
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.noticePeriod != null
                                        ? candiateDetails.noticePeriod
                                        : "-"}
                                    </div>

                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.immediateJoiner != null
                                              ? candiateDetails.immediateJoiner
                                                ? "Yes"
                                                : "No"
                                              : "-"}
                                          </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2">
                                <h6>
                                  <b>Background Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    <div style={{ lineHeight: "2" }}>
                                      current stay location?
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Previous stay type?
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Ready to relocate?
                                    </div> */}
                                  </div>
                                  <div className="col-7">
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.city != null
                                        ? candiateDetails.city
                                        : "-"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.currentStayType != null
                                              ? candiateDetails.currentStayType
                                              : "-"}
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.readyToRelocate !=
                                      null
                                        ? candiateDetails.readyToRelocate
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2">
                                <h6>
                                  <b>Previous Salary Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Previous salary?
                                    </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      Take home salary?
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Expected salary?
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Salary Document?
                                    </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Previous stay type?
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                      Exp. for same industry and job category?
                                    </div> */}
                                  </div>
                                  <div className="col-7">
                                    <div style={{ lineHeight: "2" }}>
                                      {/* {candiateDetails.adminSuggestedSalary !=
                                      null
                                        ? candiateDetails.adminSuggestedSalary
                                        : "-"} */}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.takeHomeSalary != null
                                        ? candiateDetails.takeHomeSalary
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.expectedSalary != null
                                        ? candiateDetails.expectedSalary
                                        : "-"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.salaryProofDocumentType !=
                                      null
                                        ? candiateDetails.salaryProofDocumentType
                                        : "-"}
                                    </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.currentStayType != null
                                              ? candiateDetails.currentStayType
                                              : "-"}
                                          </div> */}
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.workForSuggestedSalary !=
                                            null
                                              ? candiateDetails.workForSuggestedSalary
                                              : "-"}
                                          </div> */}
                                  </div>
                                </div>
                              </div>
                              <div className="mt-2">
                                <h6>
                                  <b>Other Details</b>
                                </h6>
                                <div
                                  className={`row ${Candidatedetailstyle.CanDetailsRow}`}
                                >
                                  <div className="col-5">
                                    <div style={{ lineHeight: "2" }}>
                                      Rotational shifts?
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Accomodation needed
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Transport needed
                                          </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      Updated CV/Resume
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      Reference
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            Immediate Joiner
                                          </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      Notice Peroid
                                    </div>
                                    <div style={{ lineHeight: "2" }}>Notes</div>
                                  </div>
                                  <div className="col-7">
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.readyForShifts != null
                                        ? candiateDetails.readyForShifts
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.needAccommodation != null
                                        ? candiateDetails.needAccommodation
                                          ? "Yes"
                                          : "No"
                                        : "-"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.needTransport != null
                                              ? candiateDetails.needTransport
                                                ? "Yes"
                                                : "No"
                                              : "-"}
                                          </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.havingUpdatedCV
                                        ? "Yes"
                                        : "No"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.reference != null
                                        ? candiateDetails.reference
                                        : "-"}
                                    </div>
                                    {/* <div style={{ lineHeight: "2" }}>
                                            {candiateDetails.immediateJoiner != null
                                              ? candiateDetails.immediateJoiner
                                                ? "Yes"
                                                : "No"
                                              : "-"}
                                          </div> */}
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.noticePeriod != null
                                        ? candiateDetails.noticePeriod
                                        : "-"}
                                    </div>
                                    <div style={{ lineHeight: "2" }}>
                                      {candiateDetails.notes != null
                                        ? candiateDetails.notes
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                        {/* </React.Fragment> */}

                        {/* {Array.isArray(candiateQualifyDetails) &&
                          candiateQualifyDetails.map((candidate, index) => (
                            <React.Fragment key={index}>
                            
                            </React.Fragment>
                          ))} */}

                        {/* {Array.isArray(candiateQualifyDetails) &&
                          candiateQualifyDetails.map((candidate, index) => (
                            <React.Fragment key={index}>
                              
                            </React.Fragment>
                          ))} */}
                      </div>
                    </div>

                    <div
                      className={` col-sm-8 rounded  ${Candidatedetailstyle.DailyDetailsupdate}`}
                    >
                      <div>
                        <div
                          className={`tab-buttons ${candidateTabsviewStyle.tab_buttons}`}
                        >
                          <div
                            className={`d-flex ${candidateTabsviewStyle.tab_hr}`}
                          >
                            <div
                              onClick={() => handleTabClick(1)}
                              className={` ${
                                activeTab === 1
                                  ? candidateTabsviewStyle.activetag
                                  : candidateTabsviewStyle.unactivetag
                              } `}
                            >
                              TimeLine
                            </div>
                            {/* {(parseInt(adminId) === candiateDetails.assignTo || isSuperAdmin) && */}
                            <div
                              onClick={() => {
                                handleTabClick(2);
                              }}
                              className={` ${
                                activeTab === 2
                                  ? candidateTabsviewStyle.activetag
                                  : candidateTabsviewStyle.unactivetag
                              }`}
                              style={{
                                pointerEvents: !(
                                  parseInt(adminId) ===
                                    candiateDetails.assignTo || isSuperAdmin
                                )
                                  ? "none"
                                  : "auto", // disables click
                                opacity: !(
                                  parseInt(adminId) ===
                                    candiateDetails.assignTo || isSuperAdmin
                                )
                                  ? 0.5
                                  : 1, // makes it look disabled
                                cursor: !(
                                  parseInt(adminId) ===
                                    candiateDetails.assignTo || isSuperAdmin
                                )
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                              aria-disabled={
                                !(
                                  parseInt(adminId) ===
                                    candiateDetails.assignTo || isSuperAdmin
                                )
                              }
                            >
                              Notes
                            </div>
                            {/* } */}
                            {/* <div
                              onClick={() => handleTabClick(3)}
                              className={` ${
                                activeTab === 3
                                  ? candidateTabsviewStyle.activetag
                                  : candidateTabsviewStyle.unactivetag
                              }`}
                            >
                              Calls
                            </div> */}
                            <div
                              onClick={() => handleTabClick(4)}
                              className={` ${
                                activeTab === 4
                                  ? candidateTabsviewStyle.activetag
                                  : candidateTabsviewStyle.unactivetag
                              }`}
                            >
                              Files
                            </div>
                            <div
                              onClick={() => {
                                handleTabClick(5);
                                handleMobileNumberChange(
                                  candiateDetails.mobileNumber
                                );
                              }}
                              className={` ${
                                activeTab === 5
                                  ? candidateTabsviewStyle.activetag
                                  : candidateTabsviewStyle.unactivetag
                              }`}
                            >
                              Interview
                            </div>
                            {/* } */}
                            <div
                              onClick={() => handleTabClick(3)}
                              className={` ${
                                activeTab === 3
                                  ? candidateTabsviewStyle.activetag
                                  : candidateTabsviewStyle.unactivetag
                              }`}
                            >
                              AI Call Logs
                            </div>
                          </div>
                          <hr style={{ borderTop: "10px solid #ccc" }} />
                        </div>

                        <div
                          className={`tab-content ${candidateTabsviewStyle.tab_content}`}
                        >
                          {candiateDetails.id && activeTab === 1 && (
                            <p>
                              <CandidateTimeline
                                canId={candiateDetails.id}
                                shouldReload={shouldReload}
                              />
                            </p>
                          )}
                          {candiateDetails.id && activeTab === 2 && (
                            <p>
                              <TimeLineForm canId={candiateDetails.id} />
                            </p>
                          )}
                          {/* {activeTab === 3 && <p>Content for Tab 3</p>} */}
                          {activeTab === 4 && (
                            <p>
                              <div
                                variant="contained"
                                onClick={() => {
                                  uploadButtonClick();
                                }}
                                style={{
                                  width: "100%",
                                  margin: "0 auto",
                                  display: "block",
                                  backgroundColor: "#169c5030",
                                  textAlign: "center",
                                  borderColor: " #169C50",
                                  borderStyle: "dotted",
                                  padding: "10px",
                                  color: "#169C50",
                                  cursor: "pointer",
                                }}
                              >
                                <MdOutlineUploadFile /> Upload
                              </div>
                              <>
                                <div>
                                  <hr style={{ margin: "8px 0" }} />
                                  {documents.map((document) => (
                                    <div key={document.id}>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <a
                                          href={document.docLink}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {renderDocumentImage(document.docKey)}
                                        </a>
                                        <div style={{ marginLeft: "10px" }}>
                                          <strong>{document.docTitle}</strong>
                                          <p
                                            style={{
                                              margin: 0,
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            Registered:{" "}
                                            <Ddmmmyyyy_date
                                              dateValue={document.createdTime}
                                            />
                                          </p>
                                        </div>
                                      </div>
                                      <hr style={{ margin: "8px 0" }} />
                                    </div>
                                  ))}
                                </div>

                                {ShowModal && (
                                  <>
                                    <MyModal>
                                      <ModalContainer
                                        zIndex={1005}
                                        open={ShowModal}
                                        onClose={() => SetShowModal(false)}
                                        childComponent={
                                          <>
                                            <div
                                              style={{
                                                width: "500px",
                                                height: "50%",
                                              }}
                                            >
                                              {" "}
                                              <div>
                                                <div
                                                  style={{
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <h6>Upload Documents</h6>
                                                </div>
                                              </div>
                                              <label
                                                htmlFor=""
                                                className="mb-2"
                                              >
                                                <b>Select Document</b>
                                              </label>
                                              <FormControl
                                                fullWidth
                                                error={!!documentTypeError}
                                              >
                                                <InputLabel id="demo-simple-select-label">
                                                  Select Document
                                                </InputLabel>
                                                <Select
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  label="Select Document"
                                                  // style={{ minWidth: "200px" }}
                                                  onChange={
                                                    handleDocumentTypeChange
                                                  }
                                                >
                                                  {documentTitles.map(
                                                    (title, index) => (
                                                      <MenuItem
                                                        key={index}
                                                        value={title}
                                                      >
                                                        {title}
                                                      </MenuItem>
                                                    )
                                                  )}
                                                </Select>
                                                <FormHelperText>
                                                  {documentTypeError}
                                                </FormHelperText>
                                              </FormControl>
                                              <div
                                                style={{ marginTop: "20px" }}
                                              >
                                                <Button
                                                  component="label"
                                                  variant="contained"
                                                  startIcon={
                                                    <CloudUploadIcon />
                                                  }
                                                  style={{
                                                    backgroundColor:
                                                      "#169c5030",
                                                    textAlign: "center",
                                                    borderColor: " #169C50",
                                                    borderStyle: "dotted",
                                                    padding: "10px",
                                                    color: "#169C50",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  Upload file
                                                  <VisuallyHiddenInput
                                                    type="file"
                                                    onChange={handleFileChange}
                                                  />
                                                </Button>
                                                {fileError && (
                                                  <div style={{ color: "red" }}>
                                                    {fileError}
                                                  </div>
                                                )}
                                                {fileName && (
                                                  <div>
                                                    Uploaded File: {fileName}
                                                  </div>
                                                )}
                                              </div>
                                              <div className="mt-3 gap-2 d-flex align-items-center justify-content-end">
                                                {" "}
                                                {/* cancel button on the left */}
                                                <button
                                                  onClick={() => {
                                                    setFileName("");
                                                    setSelectedFile(null);
                                                    SetShowModal(false);
                                                  }}
                                                  className="btn btn-danger "
                                                >
                                                  Cancel
                                                </button>
                                                {/* submit button on the right */}
                                                <button
                                                  variant="outlined"
                                                  className="btn btn-success "
                                                  onClick={submitForm}
                                                >
                                                  Submit
                                                </button>
                                              </div>
                                              <div
                                                style={{
                                                  // display: "flex",
                                                  // justifyContent: "end",
                                                  // alignItems: "center",
                                                  gap: 2,
                                                }}
                                              >
                                                <Backdrop
                                                  sx={{
                                                    color: "#fff",
                                                    zIndex: (theme) =>
                                                      theme.zIndex.drawer + 1,
                                                  }}
                                                  open={open}
                                                  onClick={handleClos}
                                                >
                                                  <CircularProgress color="inherit" />
                                                </Backdrop>
                                              </div>
                                            </div>
                                          </>
                                        }
                                      />
                                    </MyModal>
                                  </>
                                )}
                              </>
                            </p>
                          )}
                          {activeTab === 5 && (
                            <div className="container mt-3">
                              {CandidateInterviewList.length > 0 ? (
                                <div
                                  style={{
                                    maxHeight: "400px",
                                    overflowY: "auto",
                                  }}
                                >
                                  <table
                                    className="table table-bordered"
                                    style={{ borderCollapse: "collapse" }}
                                  >
                                    <thead
                                      style={{
                                        position: "sticky",
                                        top: 0,
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1,
                                      }}
                                    >
                                      <tr>
                                        <th>S.No</th>
                                        <th>ID</th>
                                        <th>Job&nbsp;Category</th>
                                        <th>Company&nbsp;Name</th>
                                        {/* <th>Scheduled&nbsp;by</th> */}
                                        <th>Interview&nbsp;Date</th>
                                        <th>Reschedule</th>
                                        <th>Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {CandidateInterviewList.map(
                                        (candidate, i) => (
                                          <tr
                                            key={i}
                                            className="align-items-center"
                                            onClick={() =>
                                              setcanInterviewDetails(
                                                candidate.CanInterviewsModel
                                              )
                                            }
                                            //
                                          >
                                            <td
                                              style={{
                                                backgroundColor:
                                                  candidate.CanInterviewsModel
                                                    .joined &&
                                                  !candidate.CanInterviewsModel
                                                    .leftTheCompany
                                                    ? "#169c5050"
                                                    : candidate
                                                        .CanInterviewsModel
                                                        .joined &&
                                                      candidate
                                                        .CanInterviewsModel
                                                        .leftTheCompany
                                                    ? "#efaf4f5b"
                                                    : "#fff",
                                              }}
                                            >
                                              <b>{i + 1}</b>
                                            </td>
                                            <td
                                              style={{
                                                backgroundColor:
                                                  candidate.CanInterviewsModel
                                                    .joined &&
                                                  !candidate.CanInterviewsModel
                                                    .leftTheCompany
                                                    ? "#169c5050"
                                                    : candidate
                                                        .CanInterviewsModel
                                                        .joined &&
                                                      candidate
                                                        .CanInterviewsModel
                                                        .leftTheCompany
                                                    ? "#efaf4f5b"
                                                    : "#fff",
                                              }}
                                            >
                                              <b>
                                                {
                                                  candidate.CanInterviewsModel
                                                    ?.id
                                                }
                                              </b>
                                            </td>

                                            <td
                                              onClick={() => {
                                                copyToClipboard(
                                                  candidate.CandidateModel
                                                    .jobCategory
                                                );
                                                handlePopupDetails(
                                                  candidate.CanInterviewsModel
                                                    .jobId,
                                                  "jobDetails"
                                                );
                                              }}
                                              style={{
                                                color: "blue",
                                                cursor: "pointer",
                                                backgroundColor:
                                                  candidate.CanInterviewsModel
                                                    .joined &&
                                                  !candidate.CanInterviewsModel
                                                    .leftTheCompany
                                                    ? "#169c5050"
                                                    : candidate
                                                        .CanInterviewsModel
                                                        .joined &&
                                                      candidate
                                                        .CanInterviewsModel
                                                        .leftTheCompany
                                                    ? "#efaf4f5b"
                                                    : "#fff",
                                              }}
                                            >
                                              {candidate.JobModel.jobCategory
                                                ?.length > 20
                                                ? `${candidate.JobModel.jobCategory.slice(
                                                    0,
                                                    20
                                                  )}...`
                                                : candidate.JobModel
                                                    .jobCategory}
                                            </td>
                                            <td
                                              onClick={() => {
                                                if (
                                                  candidate.CanInterviewsModel
                                                    ?.companyName
                                                ) {
                                                  copyToClipboard(
                                                    candidate.CanInterviewsModel
                                                      .companyName
                                                  );
                                                }
                                                if (
                                                  candidate.EmployerModel?.id
                                                ) {
                                                  handlePopupDetails(
                                                    candidate.EmployerModel.id,
                                                    "employerDetails"
                                                  );
                                                }
                                              }}
                                              style={{
                                                color: "blue",
                                                cursor: "pointer",
                                                backgroundColor:
                                                  candidate.CanInterviewsModel
                                                    .joined &&
                                                  !candidate.CanInterviewsModel
                                                    .leftTheCompany
                                                    ? "#169c5050"
                                                    : candidate
                                                        .CanInterviewsModel
                                                        .joined &&
                                                      candidate
                                                        .CanInterviewsModel
                                                        .leftTheCompany
                                                    ? "#efaf4f5b"
                                                    : "#fff",
                                              }}
                                            >
                                              {candidate.CanInterviewsModel
                                                ?.companyName?.length > 20
                                                ? `${candidate.CanInterviewsModel.companyName.slice(
                                                    0,
                                                    20
                                                  )}...`
                                                : candidate.CanInterviewsModel
                                                    ?.companyName || "-"}
                                            </td>
                                            {/* <td>
                                              {isSuperAdmin || teamLeader
                                                ? adminName[
                                                    adminid.indexOf(
                                                      candidate
                                                        .CanInterviewsModel
                                                        .adminId.length > 15
                                                        ? `${candidate.CanInterviewsModel.adminId.slice(
                                                            0,
                                                            15
                                                          )}...`
                                                        : candidate
                                                            .CanInterviewsModel
                                                            .adminId
                                                    )
                                                  ]
                                                : adminuserName}
                                            </td> */}
                                            <td
                                              style={{
                                                backgroundColor:
                                                  candidate.CanInterviewsModel
                                                    .joined &&
                                                  !candidate.CanInterviewsModel
                                                    .leftTheCompany
                                                    ? "#169c5050"
                                                    : candidate
                                                        .CanInterviewsModel
                                                        .joined &&
                                                      candidate
                                                        .CanInterviewsModel
                                                        .leftTheCompany
                                                    ? "#efaf4f5b"
                                                    : "#fff",
                                                // textAlign: "right",
                                                // paddingRight: "12px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent:
                                                    "space-between",
                                                  gap: "6px",
                                                  verticalAlign: "middle",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    fontWeight: "bold",
                                                    color: candidate
                                                      .CanInterviewsModel.active
                                                      ? "#198754"
                                                      : "#212529",
                                                    lineHeight: "1", // makes text and icon height align perfectly
                                                  }}
                                                >
                                                  <DMMMYYYY_formate
                                                    dateValue={
                                                      candidate
                                                        .CanInterviewsModel
                                                        .interviewDate
                                                    }
                                                  />
                                                  {candidate.CanInterviewsModel
                                                    .active && (
                                                    <span
                                                      style={{
                                                        color: "#000",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      (active)
                                                    </span>
                                                  )}
                                                </span>

                                                {/* <span>
                                                  {" "}
                                                  <TbCalendarRepeat
                                                    title="Reschedule Interview"
                                                    onClick={
                                                      handleOpenReschedule
                                                    }
                                                    style={{
                                                      cursor: "pointer",
                                                      color: "#2E86C1",
                                                      fontSize: "25px",
                                                      position: "relative",
                                                      top: "1px", // 👈 small nudge down for perfect alignment
                                                    }}
                                                  />
                                                </span> */}
                                              </div>
                                            </td>

                                            <td
                                              style={{
                                                backgroundColor:
                                                  candidate.CanInterviewsModel
                                                    .joined &&
                                                  !candidate.CanInterviewsModel
                                                    .leftTheCompany
                                                    ? "#169c5050"
                                                    : candidate
                                                        .CanInterviewsModel
                                                        .joined &&
                                                      candidate
                                                        .CanInterviewsModel
                                                        .leftTheCompany
                                                    ? "#efaf4f5b"
                                                    : "#fff",
                                              }}
                                            >
                                              {candidate.CanInterviewsModel
                                                .joined &&
                                              !candidate.CanInterviewsModel
                                                .leftTheCompany ? (
                                                <span
                                                  style={{
                                                    color: "#169c50",
                                                    fontWeight: "bold",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Joined
                                                </span>
                                              ) : candidate.CanInterviewsModel
                                                  .joined &&
                                                candidate.CanInterviewsModel
                                                  .leftTheCompany ? (
                                                <span
                                                  style={{
                                                    color: "#efaf4f",
                                                    fontWeight: "bold",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Left Company{" "}
                                                </span>
                                              ) : (
                                                <button
                                                  style={{
                                                    backgroundColor: "#D4E6F1",
                                                    color: "#2E86C1",
                                                    border: "1px solid #2E86C1",
                                                    padding: "3px 8px",
                                                    borderRadius: "10px",
                                                    fontSize: "15px",
                                                    cursor:
                                                      candidate
                                                        .CanInterviewsModel
                                                        .leftTheCompany ||
                                                      candidate
                                                        .CanInterviewsModel
                                                        .joined
                                                        ? "not-allowed"
                                                        : "pointer",
                                                    opacity:
                                                      candidate
                                                        .CanInterviewsModel
                                                        .leftTheCompany ||
                                                      candidate
                                                        .CanInterviewsModel
                                                        .joined
                                                        ? 1.5 // 👈 prevent fade
                                                        : 1,
                                                  }}
                                                  disabled={
                                                    candidate.CanInterviewsModel
                                                      .leftTheCompany ||
                                                    candidate.CanInterviewsModel
                                                      .joined
                                                  }
                                                  title="click"
                                                  // onClick={() => {
                                                  //   setJoiningFollowupdateupdate(
                                                  //     true
                                                  //   );
                                                  // }}
                                                  onClick={handleOpenReschedule}
                                                >
                                                  Reschedule
                                                </button>
                                              )}
                                            </td>

                                            <td
                                              style={{
                                                backgroundColor:
                                                  candidate.CanInterviewsModel
                                                    .joined &&
                                                  !candidate.CanInterviewsModel
                                                    .leftTheCompany
                                                    ? "#169c5050"
                                                    : candidate
                                                        .CanInterviewsModel
                                                        .joined &&
                                                      candidate
                                                        .CanInterviewsModel
                                                        .leftTheCompany
                                                    ? "#efaf4f5b"
                                                    : "#fff",
                                              }}
                                            >
                                              <span className="d-flex gap-2">
                                                {isSuperAdmin &&
                                                  !candidate.CanInterviewsModel
                                                    .active && (
                                                    <span
                                                      className={
                                                        Candidatedetailstyle.iconButton
                                                      }
                                                      title="interview active"
                                                      onClick={() => {
                                                        setInterviewActive(
                                                          true
                                                        );
                                                        setActiveCompanyName(
                                                          candidate.CanInterviewsModel
                                                        );
                                                      }}
                                                    >
                                                      <LuCalendarCheck2 />
                                                    </span>
                                                  )}
                                                {candidate.CanInterviewsModel
                                                  .active && (
                                                  <span
                                                    className={
                                                      Candidatedetailstyle.iconButton
                                                    }
                                                    onClick={() => {
                                                      setJoiningFollowupdateupdate(
                                                        true
                                                      );
                                                      setActiveCompanyName(
                                                        candidate.CanInterviewsModel
                                                      );
                                                    }}
                                                    title="Joining Tentative Date"
                                                  >
                                                    <LuCalendarClock />
                                                  </span>
                                                )}
                                              </span>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              ) : (
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontSize: "1.3 rem",
                                    color: "red",
                                    padding: "20px",
                                  }}
                                >
                                  No Interviews
                                </div>
                              )}
                            </div>
                          )}
                          {candiateDetails.id && activeTab === 3 && (
                            //
                            <table
                              className={Candidatedetailstyle.detailsTable}
                            >
                              <thead>
                                <tr>
                                  {importantKeys.map((item, idx) => (
                                    <th key={idx}>{item.label}</th>
                                  ))}
                                </tr>
                              </thead>

                              <tbody>
                                {callDetails?.data?.data?.length > 0 ? (
                                  callDetails.data.data.map((candidate, i) => {
                                    const details =
                                      candidate.call_details_json || {};

                                    return (
                                      <tr
                                        key={i}
                                        className={Candidatedetailstyle.dataRow}
                                        onClick={() => setShowModal(true)}
                                      >
                                        {importantKeys.map((item, idx) => {
                                          let value =
                                            details[item.key] ??
                                            candidate[item.key];

                                          // ✅ Format boolean field
                                          if (
                                            item.key ===
                                            "immediateJoinerBoolean"
                                          ) {
                                            value = value ? "Yes" : "No";
                                          }

                                          // ✅ Format created_at date
                                          if (
                                            item.key === "created_at" &&
                                            value
                                          ) {
                                            value = dateFormateDD(value);
                                          }

                                          // ✅ Truncate long text for name and role
                                          if (
                                            (item.key === "candidateName" ||
                                              item.key === "jobRole") &&
                                            typeof value === "string"
                                          ) {
                                            value =
                                              value.length > 15
                                                ? value.substring(0, 15) + "..."
                                                : value;
                                          }

                                          return (
                                            <td key={idx}>{value ?? "N/A"}</td>
                                          );
                                        })}
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={importantKeys.length}
                                      className="text-center py-3 text-danger"
                                    >
                                      <b> No AI Call Log</b>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row mt-3 " style={{ color: "#d7d5d5" }}>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Iste distinctio, culpa explicabo nihil necessitatibus quod
                    aliquid neque architecto fuga exercitationem doloremque quas
                    ducimus, accusamus suscipit soluta deleniti voluptatem illum
                  </div> */}
                </div>
              </div>
              {showConfirmationqualifiedPopup && (
                <MyModal>
                  <ModalContainer
                    zIndex={2000}
                    childComponent={
                      <>
                        <div>
                          <div className="text-center mb-3">
                            Qualify Candidate
                          </div>
                          <TextField
                            id="outlined-multiline-flexible"
                            label="Add Notes"
                            multiline
                            required
                            onChange={(event) => {
                              setIsQualifiedDetails((prev) => ({
                                ...prev,
                                notes: event.target.value,
                              }));
                            }}
                            maxRows={4}
                            fullWidth
                          />
                        </div>
                        <div className="d-flex justify-content-end gap-1 mt-4">
                          <button
                            className="btn text-white me-3"
                            onClick={handleCancelClick}
                            style={{ backgroundColor: "#d00a0a" }}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn text-white"
                            onClick={ConfirmFormSubmit}
                            // disabled={enableSubmit}
                            style={{ backgroundColor: "#169C50" }}
                          >
                            Qualify
                          </button>
                        </div>
                      </>
                    }
                  />
                </MyModal>
              )}

              {showConfirmationPopup && (
                <MyModal>
                  <ModalContainer
                    zIndex={2000}
                    childComponent={
                      <>
                        <div>
                          <div className="text-center mb-3">
                            Disqualify Candidate
                          </div>
                          <TextField
                            id="outlined-multiline-flexible"
                            label="Add Notes"
                            multiline
                            required
                            onChange={(event) => {
                              setIsQualifiedDetails((prev) => ({
                                ...prev,
                                notes: event.target.value,
                              }));
                            }}
                            maxRows={4}
                            fullWidth
                          />
                        </div>
                        <div className="d-flex justify-content-end gap-1 mt-4">
                          <button
                            className="btn text-white me-3"
                            onClick={handleCancelClicknotqualify}
                            style={{ backgroundColor: "#d00a0a" }}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn text-white"
                            onClick={ConfirmFormSubmit}
                            // disabled={enableSubmit}
                            style={{ backgroundColor: "#169C50" }}
                          >
                            Disqualify
                          </button>
                        </div>
                      </>
                    }
                  />
                </MyModal>
              )}
              {followUpDateopen && candiateDetails.id && (
                <MyModal>
                  <ModalContainer
                    zIndex={"1001"}
                    childComponent={
                      <>
                        <div style={{ width: "450px" }}>
                          {" "}
                          <p className="text-center">
                            <b>Tentative Interview Date</b>
                          </p>
                          <form action="#" onSubmit={handleSubmit}>
                            <div className="row mt-2">
                              <div className="col-sm-12 d-flex gap-3 align-item-center">
                                <label
                                  htmlFor="currentpositionDropdown"
                                  className="form-label"
                                >
                                  <strong>Tentative Date : </strong>
                                </label>
                                <div>
                                  <DatePicker
                                    selected={
                                      selectedDate.tentativeInterviewDate
                                    }
                                    onChange={(date) => {
                                      console.log(date, "Date tentative");
                                      handleDateChange(
                                        date,
                                        "tentativeInterviewDate"
                                      );
                                    }}
                                    filterDate={isSunday}
                                    minDate={new Date()}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    // withPortal={true}
                                  />
                                  {validity.isFollowDate1 ? null : (
                                    <div className="" style={{ color: "red" }}>
                                      Please select a date.
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              {dateDiff >= 4 && (
                                <div className="col-sm-12 mt-2 d-flex gap-3 align-item-center">
                                  <label
                                    htmlFor="currentpositionDropdown"
                                    className="form-label"
                                  >
                                    <strong>Follow up Date :</strong>
                                  </label>
                                  <div>
                                    <DatePicker
                                      selected={selectedDate.followUpDate1}
                                      onChange={(date) =>
                                        handleDateChange(date, "followUpDate1")
                                      }
                                      filterDate={filterFollowUpDate}
                                      minDate={new Date()}
                                      maxDate={
                                        new Date(
                                          selectedDate.tentativeInterviewDate.getTime() -
                                            2 * 24 * 60 * 60 * 1000
                                        )
                                      }
                                      dateFormat="dd/MM/yyyy"
                                      className="form-control"
                                      // withPortal={true}
                                    />
                                    {validity.isFollowDate2 ? null : (
                                      <div
                                        className=""
                                        style={{ color: "red" }}
                                      >
                                        Please select a date.
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="row mt-2">
                              <label htmlFor="">
                                <b>
                                  Enter company name and select job category :
                                </b>
                              </label>
                              <div className="col-sm-12 mt-2 mb-2 d-flex gap-3 align-item-center">
                                
                                <div className="w-100">
                                  <FormGroup>
                                    <Typeahead
                                      id="company-name-typeahead"
                                      placeholder="Company Details"
                                      options={companyNames}
                                      labelKey={(option) =>
                                        `${option.companyName} (${option.area}, ${option.city})`
                                      }
                                      selected={
                                        selectedCompany
                                          ? [JSON.parse(selectedCompany)]
                                          : []
                                      }
                                      onChange={handleCompanyNameChange}
                                      isInvalid={companyNameError}
                                    />
                                    
                                    {companyNameError && (
                                      <div className="invalid-feedback">
                                        Please select a company name
                                      </div>
                                    )}
                                  </FormGroup>
                                </div>
                               
                              </div>
                              <div className="col-sm-12">
                                {" "}
                                <div className="w-100">
                                  <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={options.jobRoles}
                                    value={selectedJobCategory}
                                    onChange={(event, newValue) => {
                                      setSelectedJobCategory(newValue);
                                      setJobCategoryError(false);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Job Category"
                                        fullWidth
                                        error={jobCategoryError}
                                        helperText={
                                          jobCategoryError
                                            ? "Job Category is required"
                                            : ""
                                        }
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-3 ">
                              <div
                                className="btn btn-danger px-4"
                                onClick={handleInterviewDateClose}
                              >
                                Close
                              </div>
                              <button
                                className="btn btn-success px-4"
                                type="submit"
                                disabled={enableSubmit}
                              >
                                Submit
                              </button>
                            </div>
                          </form>
                        </div>
                      </>
                    }
                  />
                </MyModal>
              )}
              {followUpDateopenupdate && candiateDetails.id && (
                <MyModal>
                  <ModalContainer
                    zIndex={"1001"}
                    childComponent={
                      <>
                        <div style={{ width: "450px" }}>
                          {" "}
                          <p className="text-center">
                            <b>Tentative Interview Date Update</b>
                          </p>
                          <form action="#" onSubmit={handleSubmitUpdate}>
                            <div className="row mt-2">
                              <div className="col-sm-12 d-flex gap-3 align-item-center">
                                <label
                                  htmlFor="currentpositionDropdown"
                                  className="form-label"
                                >
                                  <strong>Tentative Date : </strong>
                                </label>
                                <div>
                                  <DatePicker
                                    selected={
                                      selectedDate.tentativeInterviewDate
                                    }
                                    onChange={(date) =>
                                      handleDateChange(
                                        date,
                                        "tentativeInterviewDate"
                                      )
                                    }
                                    minDate={new Date()}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    // withPortal={true}
                                  />
                                  {validity.isFollowDate1 ? null : (
                                    <div className="" style={{ color: "red" }}>
                                      Please select a date.
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              {dateDiff >= 4 && (
                                <div className="col-sm-12 mt-2 d-flex gap-3 align-item-center">
                                  <label
                                    htmlFor="currentpositionDropdown"
                                    className="form-label"
                                  >
                                    <strong>Follow up Date :</strong>
                                  </label>
                                  <div>
                                    <DatePicker
                                      selected={selectedDate.followUpDate1}
                                      onChange={(date) =>
                                        handleDateChange(date, "followUpDate1")
                                      }
                                      minDate={new Date()}
                                      maxDate={
                                        new Date(
                                          selectedDate.tentativeInterviewDate.getTime() -
                                            2 * 24 * 60 * 60 * 1000
                                        )
                                      }
                                      filterDate={filterFollowUpDate}
                                      dateFormat="dd/MM/yyyy"
                                      className="form-control"
                                      // withPortal={true}
                                    />
                                    {validity.isFollowDate2 ? null : (
                                      <div
                                        className=""
                                        style={{ color: "red" }}
                                      >
                                        Please select a date.
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="row mt-2">
                              <label htmlFor="">
                                <b>
                                  Enter company name and select job category :
                                </b>
                              </label>
                              <div className="col-sm-12 mt-2 d-flex gap-3 align-item-center">
                                {/* <label
                                  htmlFor="currentpositionDropdown"
                                  className="form-label"
                                >
                                  <strong>Company Name:</strong>
                                </label> */}
                                {/* <div className="w-100">
                                  <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={companyNames}
                                    value={selectedCompany}
                                    onChange={handleCompanyNameChange}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Company Name"
                                        fullWidth
                                        error={companyNameError} // Apply error state
                                        helperText={
                                          companyNameError
                                            ? "Please select a company name"
                                            : ""
                                        }
                                      />
                                    )}
                                  />
                                </div> */}
                                <div className="w-100">
                                  <FormGroup>
                                    {/* <FormLabel>Company Name</FormLabel> */}
                                    <Typeahead
                                      id="company-name-typeahead"
                                      placeholder="Company Details"
                                      options={companyNames}
                                      labelKey={(option) =>
                                        `${option.companyName} (${option.area}, ${option.city})`
                                      }
                                      selected={
                                        selectedCompany
                                          ? [JSON.parse(selectedCompany)]
                                          : []
                                      }
                                      onChange={handleCompanyNameChange}
                                      isInvalid={companyNameError}
                                    />
                                    {companyNameError && (
                                      <div className="invalid-feedback">
                                        Please select a company name
                                      </div>
                                    )}
                                  </FormGroup>
                                </div>

                                {/* <div className="w-100">
                                  <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={companyNames}
                                    getOptionLabel={(option) =>
                                      `${option.companyName} (${option.area},${option.city})`
                                    }
                                    value={
                                      selectedCompany
                                        ? JSON.parse(selectedCompany)
                                        : null
                                    }
                                    onChange={handleCompanyNameChange}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Company Name"
                                        fullWidth
                                        error={companyNameError}
                                        helperText={
                                          companyNameError
                                            ? "Please select a company name"
                                            : ""
                                        }
                                      />
                                    )}
                                  />
                                </div> */}
                              </div>
                              <div className="col-sm-12 mt-2">
                                <div className="w-100">
                                  <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={options.jobRoles}
                                    value={selectedJobCategory}
                                    onChange={(event, newValue) => {
                                      setSelectedJobCategory(newValue);
                                      setJobCategoryError(false); // Clear error when selection changes
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Job Category"
                                        fullWidth
                                        error={jobCategoryError}
                                        helperText={
                                          jobCategoryError
                                            ? "Job Category is required"
                                            : ""
                                        }
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-3 ">
                              <div
                                className="btn btn-danger px-4"
                                onClick={handleInterviewDateCloseupdate}
                              >
                                Close
                              </div>
                              <button
                                className="btn btn-success px-4"
                                type="submit"
                                disabled={enableSubmit}
                              >
                                Submit
                              </button>
                            </div>
                          </form>
                        </div>
                      </>
                    }
                  />
                </MyModal>
              )}
              {deleteCandidate && (
                <MyModal>
                  <ModalContainer
                    zIndex={"1500"}
                    childComponent={
                      <div>
                        <h5>Confirmation</h5>
                        <div>
                          Are you sure you want to delete this candidate?
                        </div>

                        {/* Notes input */}
                        <div className="mt-3">
                          <label htmlFor="deleteNotes" className="form-label">
                            <b>Notes :</b>
                          </label>
                          <input
                            id="deleteNotes"
                            className="form-control"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder="Enter reason or notes"
                          />
                        </div>

                        <div className="d-flex justify-content-end flex-row mt-3">
                          <button
                            onClick={() => {
                              setdeleteCandidate(false);
                              setNotes("");
                            }}
                            className="btn btn-danger mx-3"
                          >
                            No
                          </button>
                          <button
                            onClick={deleteLead}
                            className="btn btn-success"
                            disabled={enableSubmit || notes.trim() === ""} // disable if notes is empty
                          >
                            Yes
                          </button>
                        </div>
                      </div>
                    }
                  />
                </MyModal>
              )}
              {showModal && (
                <MyModal>
                  <ModalContainer
                    zIndex={2000}
                    childComponent={(() => {
                      // ✅ Extract candidate safely
                      const candidate = callDetails?.data?.data?.[0] || {};
                      const details = candidate.call_details_json || {};

                      return (
                        <>
                          <div
                            style={{
                              width: "70vw",
                              height: "50vh",
                              overflowY: "hidden",
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <div>
                                <h5>Call Log Details</h5>
                              </div>
                              <div
                                onClick={() => setShowModal(false)}
                                className="btn btn-danger"
                              >
                                <AiOutlineClose />
                              </div>
                            </div>

                            <div className="d-flex gap-3 align-items-start">
                              {/* Left section - Basic Details */}
                              <div
                                style={{ width: "40%" }}
                                className={` ${Candidatedetailstyle.LeftSection}`}
                              >
                                <h6>
                                  <b>Basic Details:</b>
                                </h6>
                                <div className="d-flex flex-column gap-2 mt-2 mb-2">
                                  {/* Name */}
                                  <div className="d-flex align-items-center">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Name</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {details.candidateName}
                                    </div>
                                  </div>

                                  {/* Job Role */}
                                  <div className="d-flex align-items-center">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Job Role</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {details.jobRole}
                                    </div>
                                  </div>

                                  {/* Experience */}
                                  <div className="d-flex align-items-center">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Experience</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {details.yearsofExperience} Years
                                    </div>
                                  </div>

                                  {/* Preferred City */}
                                  <div className="d-flex align-items-center">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Preferred City</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {details.preferredCity}
                                    </div>
                                  </div>

                                  {/* Current Salary */}
                                  <div className="d-flex align-items-center">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Current Salary</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {details.currentSalary}
                                    </div>
                                  </div>

                                  {/* Expected Salary */}
                                  <div className="d-flex align-items-center">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Expected Salary</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {details.expectedSalary}
                                    </div>
                                  </div>

                                  {/* Current Job */}
                                  <div className="d-flex align-items-center">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Current Job</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {details.currentJob}
                                    </div>
                                  </div>

                                  {/* Created Time */}
                                  <div className="d-flex align-items-center">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Created Time</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {new Date(
                                        candidate.created_at
                                      ).toLocaleString("en-IN")}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Right section - Call Details */}
                              <div style={{ width: "60%" }}>
                                <div
                                  className={`${Candidatedetailstyle.RightSection} mb-2`}
                                >
                                  <h6>
                                    <b>Other Details:</b>
                                  </h6>

                                  {/* Immediate Joiner */}
                                  <div className="d-flex align-items-center">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Immediate Joiner</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {details.immediateJoinerBoolean ? (
                                        <span className="text-success">
                                          <b>Yes</b>
                                        </span>
                                      ) : (
                                        <span className="text-danger">
                                          <b>No</b>
                                        </span>
                                      )}{" "}
                                      ({details.immediateJoiner})
                                    </div>
                                  </div>

                                  {/* Call Status */}
                                  <div className="d-flex align-items-center mt-1">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Call Status</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {details.CallStatus}
                                    </div>
                                  </div>

                                  {/* Initiated By */}
                                  <div className="d-flex align-items-center mt-1">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Initiated By</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {capitalizeWords(candidate.initiated_by)}
                                    </div>
                                  </div>

                                  {/* Initiated From Source */}
                                  <div className="d-flex align-items-center mt-1">
                                    <div style={{ width: "35%" }}>
                                      <li>
                                        <b>Initiated From Source</b>
                                      </li>
                                    </div>
                                    <div
                                      style={{
                                        width: "5%",
                                        textAlign: "center",
                                      }}
                                    >
                                      :
                                    </div>
                                    <div style={{ width: "60%" }}>
                                      {capitalizeWords(
                                        candidate.initiated_from_source
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* Summary */}
                                <div
                                  className={Candidatedetailstyle.RightSection}
                                  style={{
                                    maxHeight: "25vh",
                                    overflowY: "auto",
                                  }}
                                >
                                  <h6>
                                    <b>Call Summary:</b>
                                  </h6>
                                  <p style={{ marginTop: "10px" }}>
                                    {details.overallCandidateSummary}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })()}
                  />
                </MyModal>
              )}

              {joiningFollowupdateupdate && candiateDetails.id && (
                <MyModal>
                  <ModalContainer
                    zIndex={"1500"}
                    childComponent={
                      <>
                        <div style={{ width: "450px" }}>
                          {" "}
                          <div className="text-center">
                            <b>Joining Tentative Date </b>
                          </div>
                          <div className="text-center mt-1 mb-1">
                            {activeCompanyName?.companyName &&
                              `(${activeCompanyName.companyName})`}
                          </div>
                          <form action="#" onSubmit={handlejoiningSubmitUpdate}>
                            <div className="row mt-2">
                              <div className="col-sm-12 d-flex gap-3 align-item-center">
                                <label
                                  htmlFor="currentpositionDropdown"
                                  className="form-label"
                                >
                                  <strong>Tentative Date : </strong>
                                </label>
                                <div>
                                  <DatePicker
                                    selected={
                                      joiningselectedDate.tentativeJoinedDate
                                    }
                                    onChange={(date) =>
                                      handlejoiningDateChange(
                                        date,
                                        "tentativeJoinedDate"
                                      )
                                    }
                                    minDate={new Date()}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control"
                                    // withPortal={true}
                                  />
                                  {joiningvalidity.isFollowDate1 ? null : (
                                    <div className="" style={{ color: "red" }}>
                                      Please select a date.
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              {dateDiff1 >= 4 && (
                                <div className="col-sm-12 mt-2 d-flex gap-3 align-item-center">
                                  <label
                                    htmlFor="currentpositionDropdown"
                                    className="form-label"
                                  >
                                    <strong>Follow up Date :</strong>
                                  </label>
                                  <div>
                                    <DatePicker
                                      selected={
                                        joiningselectedDate.followUpDate1
                                      }
                                      onChange={(date) =>
                                        handlejoiningDateChange(
                                          date,
                                          "followUpDate1"
                                        )
                                      }
                                      minDate={new Date()}
                                      maxDate={
                                        new Date(
                                          joiningselectedDate.tentativeJoinedDate.getTime() -
                                            2 * 24 * 60 * 60 * 1000
                                        )
                                      }
                                      dateFormat="dd/MM/yyyy"
                                      className="form-control"
                                      // withPortal={true}
                                    />
                                    {joiningvalidity.isFollowDate2 ? null : (
                                      <div
                                        className=""
                                        style={{ color: "red" }}
                                      >
                                        Please select a date.
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-3 ">
                              <div
                                className="btn btn-danger px-4"
                                onClick={handleJoiningDateCloseupdate}
                              >
                                Close
                              </div>
                              <button
                                className="btn btn-success px-4"
                                type="submit"
                                disabled={enableSubmit}
                              >
                                Submit
                              </button>
                            </div>
                          </form>
                        </div>
                      </>
                    }
                  />
                </MyModal>
              )}
              {openCallRemainder && (
                <>
                  <MyModal>
                    <ModalContainer
                      zIndex={1003}
                      childComponent={
                        <>
                          <div style={{ width: "400px" }}>
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <b>Add Call Remainder</b>
                              </div>
                              <div className="btn btn-outline-danger ">
                                <AiOutlineClose
                                  onClick={handleCloseCallRemainder}
                                />
                              </div>
                            </div>
                            <form
                              onSubmit={(e) => handleOnsubmitCallRemainder(e)}
                            >
                              <label htmlFor="">Follow up date : </label>
                              <input
                                type="datetime-local"
                                id="date"
                                name="date"
                                min={localTime.toISOString().slice(0, -8)}
                                max={maxDate.toISOString().slice(0, -8)}
                                className="form-control"
                                onChange={(e) => {
                                  const inputDateTime = e.target.value;
                                  const formattedDateTime =
                                    inputDateTime + ":00"; // Append ":00" for seconds
                                  handleCallRemainderChange(
                                    "date",
                                    formattedDateTime
                                  );
                                }}
                                required
                              />

                              <div>
                                {" "}
                                <TextField
                                  label="Add Notes"
                                  multiline
                                  value={callRemainder.notes}
                                  onChange={(e) => {
                                    handleCallRemainderChange(
                                      "notes",
                                      e.target.value
                                    );
                                  }}
                                  variant="outlined"
                                  fullWidth
                                  required
                                  margin="normal"
                                />
                              </div>
                              <LoadingButton
                                type="submit"
                                loading={showLoader}
                                variant="outlined"
                                disabled={enableSubmit}
                              >
                                <span>Submit</span>
                              </LoadingButton>
                            </form>
                          </div>
                        </>
                      }
                    />
                  </MyModal>
                </>
              )}
              {showSuccess && (
                <MyModal>
                  <ModalContainer
                    zIndex={2000}
                    childComponent={<SuccessTick HeadText="Successfully" />}
                  />
                </MyModal>
              )}
              {oponUpdateForm && (
                <>
                  <MyModal>
                    <ModalContainer
                      zIndex={"1500"}
                      childComponent={
                        <>
                          <div
                            className={`container d-flex align-itmes-center justify-content-between`}
                          >
                            <div className="">
                              <p>
                                <b>Candidate qualify form</b>
                              </p>
                              <div className="d-flex">
                                {" "}
                                <div
                                  className={`me-2  ${accordionstyle.radioInput}`}
                                >
                                  {/* <label className="form-check-label me-3"> */}
                                  <input
                                    type="radio"
                                    name="fresher"
                                    id="fresherYes"
                                    value="fresher"
                                    className={`form-check-input `}
                                    checked={selectedOption === "fresher"}
                                    onChange={handleOptionChange}
                                  />
                                  <label for="fresherYes">Fresher</label>
                                  {/* </label> */}
                                </div>
                                <div
                                  className={`me-2  ${accordionstyle.radioInput}`}
                                >
                                  <label className="form-check-label">
                                    <input
                                      type="radio"
                                      name="experience"
                                      id="experienceNo"
                                      value="experience"
                                      className={`form-check-input `}
                                      checked={selectedOption === "experience"}
                                      onChange={handleOptionChange}
                                    />
                                    <label for="experienceNo">Experience</label>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="ms-5">
                              <div
                                className="btn btn-outline-danger"
                                onClick={handleCloseupdateForm}
                              >
                                <AiOutlineClose />{" "}
                              </div>
                            </div>
                          </div>

                          <div>
                            <div>
                              {selectedOption === "fresher" ? (
                                <>
                                  {/* <div className={`${accordionstyle.Container}`}> */}{" "}
                                  <UpdateFresherForm
                                    mobilenumber={candiateDetails.mobileNumber}
                                    whatsappNumber={
                                      candiateDetails.whatsappNumber
                                    }
                                    Reloadpage={handleQualifyFormSubmit}
                                  />
                                  {/* </div> */}
                                </>
                              ) : selectedOption === "experience" ? (
                                // <ExperinenceWorkingform
                                //   mobilenumber={currentMetaDetail.mobileNumber}
                                // />
                                <UpdateExperienceForm
                                  mobileNumber={candiateDetails.mobileNumber}
                                  whatsappNumber={
                                    candiateDetails.whatsappNumber
                                  }
                                  Reloadpage={handleQualifyFormSubmit}
                                />
                              ) : null}
                            </div>
                          </div>
                        </>
                      }
                    />
                  </MyModal>
                </>
              )}
              {oponResetCandidate && (
                <MyModal>
                  <ModalContainer
                    zIndex={"1500"}
                    childComponent={
                      <>
                        <div className="mb-3">
                          <b>Confirmation</b>
                        </div>
                        <div>
                          Are you sure you want to reset this candidate's
                          pipeline data?
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "20px",
                          }}
                        >
                          <button
                            style={{
                              padding: "8px 16px",
                              fontSize: "14px",
                              borderRadius: "4px",
                              backgroundColor: "#BB2D3B",
                              color: "#fff",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => setoponResetCandidate(false)}
                          >
                            Cancel
                          </button>
                          <button
                            style={{
                              padding: "8px 16px",
                              fontSize: "14px",
                              borderRadius: "4px",
                              backgroundColor: "#169C50",
                              color: "#fff",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={handleConfirmReset}
                            disabled={enableSubmit}
                          >
                            Confirm
                          </button>
                        </div>
                      </>
                    }
                  />
                </MyModal>
              )}
              {interviewActive && (
                <>
                  <MyModal>
                    <ModalContainer
                      zIndex={"1500"}
                      childComponent={
                        <>
                          <div className="mb-3">
                            <b>Confirmation</b>
                          </div>
                          <div>
                            Are you sure you want to active this interview -{" "}
                            <b>{activeCompanyName.companyName}</b>?
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginTop: "20px",
                            }}
                          >
                            <button
                              style={{
                                padding: "8px 16px",
                                fontSize: "14px",
                                borderRadius: "4px",
                                backgroundColor: "#BB2D3B",
                                color: "#fff",
                                border: "none",
                                cursor: "pointer",
                              }}
                              onClick={() => setInterviewActive(false)}
                            >
                              Cancel
                            </button>
                            <button
                              style={{
                                padding: "8px 16px",
                                fontSize: "14px",
                                borderRadius: "4px",
                                backgroundColor: "#169C50",
                                color: "#fff",
                                border: "none",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                handleInterviewActive(activeCompanyName);
                              }}
                              disabled={enableSubmit}
                            >
                              Active
                            </button>
                          </div>
                        </>
                      }
                    />
                  </MyModal>
                </>
              )}
              {isEditing && (
                <MyModal>
                  <ModalContainer
                    zIndex={1700}
                    childComponent={
                      <>
                        {" "}
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ width: "300px" }}
                        >
                          <div>
                            <b>Update From Source</b>
                          </div>
                          <div
                            className="btn btn-danger"
                            onClick={() => {
                              setIsEditing(false);
                            }}
                          >
                            <AiOutlineClose />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="d-flex align-items-center col-sm-12">
                            <Autocomplete
                              options={sources}
                              value={updateName.fromSource || ""}
                              onChange={(event, newValue) => {
                                handleFieldChange("fromSource", newValue || "");
                              }}
                              componentsProps={{
                                popper: {
                                  sx: {
                                    zIndex: 2000,
                                  },
                                },
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Source" />
                              )}
                              fullWidth
                              clearOnEscape
                            />
                            <button
                              className="btn"
                              style={{
                                borderRadius: "50%",
                                fontSize: "36px",
                                marginTop: "10px",
                              }}
                              title="Change From Source"
                              onClick={() => submitNameChange(editingId)}
                            >
                              <IoMdCheckmarkCircle
                                style={{ color: "#169c50" }}
                              />
                            </button>
                          </div>
                        </div>
                      </>
                    }
                  />
                </MyModal>
              )}
              {openReschedule && (
                <InterviewReschedule
                  interviewId={canInterviewDetails.id}
                  onSuccess={() => {
                    handleReset();
                    closeRescheduleModal();
                  }}
                  onClose={closeRescheduleModal}
                />
              )}
            </>
          }
        />
      </Detailsshow>
    </div>
  );
};

export default CandidateDetailsview;
